<template>

  <div id="app">
    <br/>

    <br> 

    <!-- confirm minor modal -->
    <b-modal id="modal-minorModal" centered size="md" v-bind:hide-footer="true" title="Minor Detail">
      <p class="h7">If you have minor in your group, please click on yes and add the minor. If not please click on no and proceed to next step.</p>
      <br>
      <b-button variant="primary" v-on:click="hideMinorModal()">Ok</b-button>

    </b-modal>

    <!-- confirm booker profile modal -->
    <b-modal id="modal-confirmBookerProfile" centered size="md" v-bind:hide-footer="true" title="Profile Confirmation">
      <p class="h7">
        <!-- Just for confirmation you made this reservation?  -->
        Please confirm that you made this reservation.
      </p>
      <br>
      <b-button variant="primary" v-on:click="bookerProfileConfirmation()">Confirm</b-button>
      <b-button variant="info" v-on:click="hideBookerProfileCheck()" style="margin-left: 1%;">Cancel</b-button>

    </b-modal>

    <!-- disable submt clicked -->
    <b-modal id="modal-confirmProfile" centered size="md" v-bind:hide-footer="true" title="Profile Confirmation">
      <p class="h7">You selected <span style="text-transform:capitalize;">{{first_name}} {{last_name}}</span> with
        Date of Birth: {{secureDateOfBirth}} <span v-if="securePhoneNumber != 'N/A'">and Phone Number: {{securePhoneNumber}}</span>. Is this you?</p>
        <br>
        <b-button variant="primary" v-on:click="verifyProfile()">Confirm</b-button>
        <b-button variant="info" v-on:click="hideProfileConfirmation()" style="margin-left: 1%;">Cancel</b-button>

      </b-modal>


      <!-- disable submt clicked -->
      <b-modal id="modal-disableSubmitClicked" centered size="md" v-bind:hide-footer="true" title="Valid Email / Phone number">
        <p class="h6">Please provide valid email and phone number then click on submit.</p>
        <br>
        <b-button variant="primary" id="needhelp1" v-on:click="closeDisableSubmitModal()">Ok</b-button>
      </b-modal>

      <!-- disable booker submt clicked -->
      <b-modal id="modal-disableBookerSubmitClicked" centered size="md" v-bind:hide-footer="true" title="Occasion">
        <p class="h6">Please select one of the occasion. If you select other please provide response with minimum 5 characters.</p>
        <br>
        <b-button variant="primary" id="needhelp" v-on:click="hideDisableBookerSubmitClicked()">Ok</b-button>
      </b-modal>

      <!-- multiple profile modal -->
      <b-modal id="modal-multipleProfileFound" centered size="lg" v-bind:hide-footer="true" title="Profile Detail">
        <div>
          <!-- this will ask for booker or not? -->

       <!--  <div>
          <p class="h6"> Did you make the reservation ? </p>
          <b-form-group>
            <b-form-radio-group
              id="radio-group-1"
              v-model="bookerOrNot"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>

          <b-form-group style="margin-top:-1.2%;">
            <b-form-radio-group
              id="radio-group-2"
              v-model="selected"
              :aria-describedby="ariaDescribedby"
              name="radio-sub-component"
            >
              <b-form-radio value="booker" v-model="bookerOrNot">Yes, I am booker.</b-form-radio>
              <b-form-radio value="notBooker" v-model="bookerOrNot" selected>No</b-form-radio>
            </b-form-radio-group>
          </b-form-group>

        </div> -->

        <div v-if="bookerOrNot == 'booker'">
          <br>
          <b-button variant="info" v-on:click="confirmBookerModal()">Submit</b-button>
        </div>

        <div v-if="bookerOrNot == 'notBooker'">
          <br>
          <p class="h6"><b>We found a profile associated with that email. Please click on the profile which is yours.</b></p>
          <hr>
        </div>

        <!-- end of div for profile integration -->
      </div>
      <table class="table table-borderless" v-if="bookerOrNot == 'notBooker'">
        <tr>
          <th>Full Name</th>
          <th>Date of birth</th>
          <!-- <th>Gender</th> -->
          <!-- <th>Email</th> -->
          <th>Phone Number</th>
        </tr>
        <tr v-for="(label,index) in profileDetail" v-bind:key="label.id">
          <td style="text-transform:capitalize;"><a :href="'/#/' + bookerOrderId" @click="confirmProfile(index)">{{label.first_name}} {{label.last_name}}</a></td>
          <td>{{label.date_of_birth | convertDob(index)}}</td>
          <!-- <td>{{label.gender_id | convertGender(gender_id)}}</td> -->
          <!-- <td>{{label.email | convertEmail(email)}}</td> -->
          <td>{{label.phone | convertPhone(phone)}}</td>
        </tr>
      </table>
      <!-- <br>
      <b-button variant="primary" v-on:click="clickedSubmitReservation">Submit</b-button>
      <b-button variant="info" v-on:click="hideSubmitReservation" style="margin-left:2%;">Cancel</b-button> -->
    </b-modal>

    <!-- profile detail phone modal -->
    <b-modal id="modal-profileDetailPhone" centered size="md" v-bind:hide-footer="true">

      <p>We found a profile of that email, to verify its you. Please type your phone number below.</p>
      <table class="table table-borderless" style="text-transform:capitalize; border: none;">
        <tr style="font-weight:bold;">
          <td>Phone Number</td>
          <td style="text-transform:capitalize;">
            <span v-if="phoneIncorrectText == true">Phone number did not match. Please try again.</span>
            <b-form-input type="text" v-model="profilePhoneDetailVerify" :placeholder="validateProfileDetailPhone" @input="verifyProfile()"></b-form-input>
          </td>
        </tr>
      </table>
      <!-- <br>
      <b-button variant="primary" v-on:click="clickedSubmitReservation">Submit</b-button>
      <b-button variant="info" v-on:click="hideSubmitReservation" style="margin-left:2%;">Cancel</b-button> -->
    </b-modal>

    <!-- <link rel="shortcut icon" type="image/png" src="./assets/btb.png"/> -->
    <link rel="icon" href="<%= BASE_URL %>btb.png">

    <div v-if="onlinewaiver !='1' ">
      <a href="/"><img center src="./assets/btb.png" alt="BTB LOGO" id="btbImageLogo" width="50%"></img></a>
    </div>
    <div v-else>
      <img center src="./assets/btb.png" alt="ONLINE BTB LOGO" id="btbImageLogo" width="50%"></img>
    </div>
    <br><br>

    <br/>
    <div>
      <span id="greetings">{{ greetings }}</span>
    </div>

    <hr>
    <div v-show="reservationTimeDiv">

      <br>

      <span id="selectReservationTime">{{ reservationTimeTitle }}</span>

      <br> <br>

      <!-- this is the part that displays the time -->
      <div v-for="time in uniqueNames" v-bind:key="time.id">
          <!-- <b-button block pill variant="outline-info" ref="sandes" id="fetchButtonGap" v-model:value="time" v-on:click="showTheTime(); reservationTimeDiv = !reservationTimeDiv ; reservationNameDiv = !reservationNameDiv ;">
            {{time}}
          </b-button> -->
        </div>
        <!-- end of time display div -->

        <br><br>

        <b-container class="bv-example-row">
          <b-row>

            <b-col>

            </b-col>

            <b-col>

              <!-- <b-button variant="primary" v-on:click="showAllTime(); allreservationamediv = !allreservationamediv, reservationTimeDiv = !reservationTimeDiv; getallreservation();">Need Help?</b-button> -->
              <b-button variant="primary" id="needhelp1" v-on:click="displayAllBookings(); allreservationamediv = !allreservationamediv, reservationTimeDiv = !reservationTimeDiv;">Need Help?</b-button>

            </b-col>

            <b-col>

            </b-col>

          </b-row>

        </b-container>


        <div>


        </div>

        <br> <br>

      </div>

      <!-- online waiver WARNING PAGE -->
      <div v-show='!onlineWarning' class="waiverSubmittedClass">
        <span> "Sorry, the link you have is incorrect. <br><br>
          Please check your email and try again.
          <br/><br/>
          If you continue to have issues, reach out to info@beatthebomb.com with your Reservation ID or sign your waiver in person at Beat The Bomb." <br><br>
        </span>
        <br/> <br/>
      </div>

      <div v-show='!onlineWarningJustLink' class="waiverSubmittedClass">
        <span> "Sorry, the link you have is incorrect. <br><br>
          Please check your email and try again.
          <br/><br/>
          If you continue to have issues, reach out to info@beatthebomb.com with your Reservation ID or sign your waiver in person at Beat The Bomb." <br><br>
        </span>
        <br/> <br/>
      </div>
      <!-- end of online waiver warning -->

      <!-- this div list all the name of reservation -->
      <div v-show="!allreservationamediv">
        <br><br>

        <span id="selectReservationName">{{ reservationNameTitle }}</span>

        <br><br>

        <div>
          <div v-for="(post, index) in allReservationDetail" :key="post.id">
            <b-button block pill variant="outline-info" id="fetchButtonGap" v-on:click="bookerNameGetHelp(index); allreservationamediv = !allreservationamediv, emailPhone = !emailPhone" v-if="post.Booker.Person.last_name == 'undefined'" style="text-transform: capitalize;">
              {{post.Booker.Person.first_name}}
            </b-button>

            <b-button block pill variant="outline-info" id="fetchButtonGap" v-on:click="bookerNameGetHelp(index); allreservationamediv = !allreservationamediv, emailPhone = !emailPhone" v-else style="text-transform: capitalize;">
              {{post.Booker.Person.first_name}} {{post.Booker.Person.last_name}}
            </b-button>

          </div>

          <!-- <div v-if="!allbookings.length"><br><span style="font-size:1.1em; color: #17a2b8;">{{ noBookingTitle }}</span><br/></div> -->

        </div>

        <br><br>
        <b-container class="bv-example-row">
          <b-row>
            <b-col>
              <b-button variant="outline-info" v-on:click="allreservationamediv = !allreservationamediv, reservationTimeDiv = !reservationTimeDiv">BACK</b-button>
            </b-col>

            <b-col></b-col>


            <b-col>
              <div id="bookingNameModal">
                <b-button v-b-modal="'modalNameList1'" id="needhelp2">Need Help?</b-button>

                <b-modal id="modalNameList1" centered title="Booking Name Required">
                  <p class="my-4">Please ask the front desk staff for assistance.</p>
                </b-modal>
              </div>

            </b-col>


          </b-row>

        </b-container>

      </div>
      <!-- end of list all name of reservation  -->


      <div v-show="!reservationNameDiv">

        <!-- <div v-for="LoadingScreen"/> -->

        <br><br>

        <span id="selectReservationBookerName">{{ reservationNameTitle }}</span>

        <br><br>
        <div id="hideDiv" style="visibility:hidden;">
          <div v-for="(post, index) in posts" :key="post.id">
            <!-- <b-button block pill variant="outline-info" id="fetchButtonGap" v-on:click="bookerName(index); reservationNameDiv = !reservationNameDiv, fullnameDiv = !fullnameDiv">
              <p v-if="post.Booker.Person.last_name == 'undefined'">{{post.Booker.Person.first_name}}</p>
              <p v-else>{{post.Booker.Person.first_name}} {{post.Booker.Person.last_name}}</p>
            </b-button> -->

            <b-button block pill variant="outline-info" id="fetchButtonGap" v-on:click="bookerName(index); reservationNameDiv = !reservationNameDiv, emailPhone = !emailPhone" v-if="post.Booker.Person.last_name == 'undefined'" style="text-transform: capitalize;">
              {{post.Booker.Person.first_name}}
            </b-button>

            <b-button block pill variant="outline-info" id="fetchButtonGap" v-on:click="bookerName(index); reservationNameDiv = !reservationNameDiv, emailPhone = !emailPhone" v-else style="text-transform: capitalize;">
              {{post.Booker.Person.first_name}} {{post.Booker.Person.last_name}}
            </b-button>

          </div>

          <!-- <div v-if="!posts.length"><br><span style="font-size:1.1em; color: #17a2b8;">{{ noBookingTitle }}</span><br/></div> -->

        </div>
        <br><br>

        <b-container class="bv-example-row">
          <b-row>
            <b-col>
              <b-button variant="outline-info" v-on:click="reservationNameDiv = !reservationNameDiv, reservationTimeDiv = !reservationTimeDiv">BACK</b-button>
            </b-col>

            <b-col></b-col>


            <b-col>
              <div id="bookingNameModal">
                <b-button v-b-modal="'modalName'" id="needhelp2">Need Help?</b-button>

                <b-modal id="modalName" centered title="Booking Name Required">
                  <p class="my-4">Please ask the front desk staff for assistance.</p>
                </b-modal>
              </div>

            </b-col>


          </b-row>

        </b-container>


        <br> <br>

      </div>


      <!-- div that will ask for email / phone for profile integration -->
      <div v-show="!emailPhone">

        <div>
          <b-form-group id="input-group-1" class="nameTitle">Are you the person who made the original reservation?</b-form-group>
          <b-form-group class="nameTitle">
            <b-form-radio-group
            id="radio-group-2"
            v-model="selected1"
            :aria-describedby="ariaDescribedby"
            name="radio-sub-component1"
            >
            <b-form-radio value="yes" v-model="clickedOnBooker"  v-on:change="clickedOnBookerDiv($event)">
              Yes
            </b-form-radio>
            <b-form-radio value="no" v-model="clickedOnBooker"  v-on:change="clickedOnBookerDiv($event) ;">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

        <div v-if="bookerOrNot == 'booker'">

          <b-form-group id="input-group-1" class="nameTitle"> Are you <span style="text-transform:capitalize;">{{bookerFirstName}} {{bookerLastName}}</span> ? </b-form-group>
          <b-form-group class="nameTitle">
            <b-form-radio-group
            id="radio-group-2"
            v-model="selected"
            :aria-describedby="ariaDescribedby"
            name="radio-sub-component"
            >
            <b-form-radio value="booker" v-model="bookerOrNot" @change="displayOcassionFunction('yes')">
              Yes
            </b-form-radio>
            <b-form-radio value="notBooker" v-model="bookerOrNot" @change="displayOcassionFunction('no')">No</b-form-radio>
          </b-form-radio-group>
        </b-form-group>



        <div v-if="bookerOrNot == 'booker' && bookerPhoneWasNull == '1'">

          <b-form-group
          id="input-group-1" class="nameTitle"> <span style="text-transform:capitalize;">{{bookerFirstName}} {{bookerLastName}}</span> Phone Number<span style="color:red; font-style: italic; font-size: 15px;"> ( Required &#42; )</span> <span v-show="!validatePhoneTextFalse" id="validationError">
          Please enter a valid phone number</span>
        </b-form-group> 

        <b-form-group>
          <b-form-input
          id="inputField"
          v-model="phone"
          type="tel"
          required
          placeholder="Enter Youre Cell Phone Number" size="lg" @input="klaviyoSmsConsent()" @blur="validationPhoneText">
        </b-form-input>
      </b-form-group>

    </div>

    <b-form-group id="input-group-1" class="nameTitle" v-if="displayOcassionText == '1' "> What is the occasion for your reservation with Beat The Bomb? </b-form-group>

    <b-form-group class="nameTitle"  v-if="displayOcassionText =='1' ">
      <b-form-radio-group
      v-model="Occasion"
      :options="OccasionOptions"
      class="mb-3"
      value-field="id"
      text-field="name" v-on:input="ocasionAnswerValidation"
      name="radios-stacked"
      stacked
      ></b-form-radio-group>

      <div v-if="Occasion == '18'">
        <span style="color:red; font-size: 0.8em; font-style: italic;" v-if="OccasionSurveyTextField.length < '5' ">Please provide response with minimum 5 characters</span>

        <span style="color:red; font-size: 0.8em; font-style: italic;" v-if="OccasionSurveyTextField.length > '4' "> </span>
        <b-form-textarea id="textarea" placeholder="What was the Occasion?" class="mbInputField" v-on:keyup.enter="onClickedGo" v-model="OccasionSurveyTextField" @input="vaidateOccasionOtherOption()" type="text"></b-form-textarea>

      </div>

    </b-form-group>

    <div v-if="bookerOrNot == 'booker'">
      <b-button variant="outline-info" v-if="Occasion > '0' && validateOccasionOther == true " @click="bookerProfileConfirmation();increaseHeightForInstagram='0'">Submit</b-button>
      <b-button variant="outline-info" v-else @click="disableBookerSubmitClicked()">Submit</b-button>
    </div>

    <div v-if="increaseHeightForInstagram === '1' && bookerOrNot == 'booker'" style="height: 450px;">
      <p> </p>
    </div>
    <div v-else>
      <p> </p>
    </div>

  </div>

  <!-- <div v-if="bookerOrNot == 'notBooker'"> -->
    <div v-if="bookerOrNot == 'notBooker' ">

      <br>
      <b-form-group
      id="input-group-1" class="nameTitle"> Enter Individual or Parent/Guardian Email Address <span style="color:red; font-style: italic; font-size: 15px;"> ( Required &#42; )</span>  <span v-show="!ValidateEmailTextFalse" id="validationError">
      Please enter a valid email address</span>
    </b-form-group>

    <b-form-group>
      <b-form-input id="inputField" v-model="email" type="email" required
      placeholder="Enter Email Address" size="lg" @blur="validationEmailText()" @input="correctEmailSecondTime()">
    </b-form-input>
  </b-form-group>

  <br>

  <b-form-group
  id="input-group-1" class="nameTitle"> Enter Individual or Parent/Guardian Phone Number <span style="color:red; font-style: italic; font-size: 15px;"> ( Required &#42; )</span> <span v-show="!validatePhoneTextFalse" id="validationError">
  Please enter a valid phone number</span>
</b-form-group> 

<b-form-group>
  <b-form-input
  id="inputField"
  v-model="phone"
  type="tel"
  required
  placeholder="Enter Cell Phone Number" size="lg" @input="klaviyoSmsConsent()" @blur="validationPhoneText">
</b-form-input>
</b-form-group>

<b-form-group>
  <!-- <b-row sm="5"> -->
    <table align="center">
      <tr>
        <td>
          <input type="checkbox" id="jack" v-model="checkMarketingConsent" @change="marketingConsent($event,1)" checked style="-ms-transform: scale(1.5); 
          -moz-transform: scale(1.5); 
          -webkit-transform: scale(1.5); 
          -o-transform: scale(1.5);
          transform: scale(1.5); margin-bottom: 20px; margin-right: 5px;"></td>
          <td><p style="color:grey; font-size:13px;">By checking this box, you consent to receiving SMS messages with your free photos & videos along with additional marketing communications. You may opt out at any time in the future.</p>
          </td>
        </tr>
      </table>
      <!-- </b-row> -->


    </b-form-group>

    <b-button variant="outline-info" v-if="validatePhoneTextFalse == true && ValidateEmailTextFalse == true && phone.length > '0' && email.length > '5' " @click="profileCheck()">Submit</b-button>
    <b-button variant="outline-info" v-else @click="disableSubmitClicked()">Submit</b-button>

  </div>

</div> 
<!-- end of div for profile integration -->

<!-- start of full name div -->
<div v-show="!fullnameDiv">
  <!-- <p>This is full name div </p> -->

  <br>

  <b-form v-if="show">

    <b-form-group id="input-group-1" class="nameTitle" label-for="input-1"> Enter Individual or Parent/Guardian First Name 
      <!-- <span v-show="!validateFirstNameTextFalse" id="validationError">Please enter a valid first name.</span> -->
      <span v-show="!validateFirstNameTextFalse" id="validationError">Please enter a valid first name.</span>
    </b-form-group> 

    <b-form-group>

      <b-form-input
      id="inputField" class="mbInputField"
      v-model="first_name" v-on:keyup.enter="onClickedGo"
      type="text"
      required
      placeholder="Enter your first name" size="lg"
      @blur="validateFirstNameText" style="text-transform:capitalize;" v-if="firstNameDisabled == true" disabled>
    </b-form-input>

    <b-form-input
    id="inputField" class="mbInputField"
    v-model="first_name" v-on:keyup.enter="onClickedGo"
    type="text"
    required
    placeholder="Enter your first name" size="lg"
    @blur="validateFirstNameText" style="text-transform:capitalize;" v-else>
  </b-form-input>

</b-form-group>

<br/>

<b-form-group 
id="input-group-1" class="nameTitle" label-for="input-1"> Enter Individual or Parent/Guardian Last Name 
<!-- <span v-show="!validateLastNameTextFalse" id="validationError">Please enter a valid last name.</span> -->
<span v-show="!validateLastNameTextFalse" v-if="last_name.length < '1' " id="validationError">Please enter a valid last name.</span>
</b-form-group> 

<!--   <b-form-group
  id="input-group-1"
  label="Last Name"
  label-for="input-1" class="nameTitle">
  </b-form-group>
-->
<b-form-group>

  <b-form-input
  id="inputField"
  v-model="last_name" class="mbInputField" v-on:keyup.enter="onClickedGo"
  type="text"
  required
  placeholder="Enter your last name" size="lg" @blur="validateLastNameText" style="text-transform:capitalize;" v-if="lastNameDisabled == true"
  disabled></b-form-input>

  <b-form-input
  id="inputField"
  v-model="last_name" class="mbInputField" v-on:keyup.enter="onClickedGo"
  type="text"
  required
  placeholder="Enter your last name" size="lg" @blur="validateLastNameText" style="text-transform:capitalize;" v-else
  ></b-form-input>

  <br/>

</b-form-group>

  <!-- <b-form-group
  id="input-group-1"
  label="Date of Birth"
  label-for="input-1" class="nameTitle"> -->

  <b-form-group id="input-group-1 dateText" class="nameTitle" label-for="input-1"> 
    Date of birth <span style="color:red;">*</span> <span v-show="!validationDOBTextFalse" id="validationError">You must be over 18 to sign the waiver.</span>
  </b-form-group>

  <b-form-input
  id="inputField"
  v-model="date_of_birth" class="mbInputField"
  type="text"
  required size="lg" v-if="dateOfBirthDisabled == true" disabled
  ></b-form-input>

  <b-form-group>

    <dropdown-datepicker display-format="mdy"  class ="dateOfBirthStyle" v-model="date_of_birth" v-bind:min-age="6" minYear="1940" @input="validationDOBText" v-if="dateOfBirthDisabled == true" style="display:none;"></dropdown-datepicker>

    <dropdown-datepicker display-format="mdy"  class ="dateOfBirthStyle" v-model="date_of_birth" v-bind:min-age="6" minYear="1940" @input="validationDOBText" v-else></dropdown-datepicker>

  </b-form-group>

  <!-- <input type="text" name="" v-model="date_of_birth"> -->

  <br>

  <b-form-group v-if="onlinewaiver != '1' " id="input-group-1" class="nameTitle" label-for="input-1">Are you playing Beat The Bomb today?
    <br><br>
    <b-form-group v-if="onlinewaiver != '1' ">
      <b-form-radio-group id="radio-group-2" v-model="playerSelected" name="plain-inline" plain>
        <b-form-radio value="yes">YES</b-form-radio>
        <b-form-radio value="no">NO</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

  </b-form-group>
      <!-- <b-form-radio-group id="radio-group-2" v-model="playerSelected" name="radio-sub-component">
        <b-form-radio value="yes">YES</b-form-radio>
        <b-form-radio value="no">NO</b-form-radio>
      </b-form-radio-group>
    </b-form-group> -->

  <!-- <b-form-group v-if="onlinewaiver == '0' " id="input-group-1" class="nameTitle" label-for="input-1">In what capacity are you filling out this waiver?</b-form-group>
  <b-form-group id="areYouPlayerDiv" v-if="onlinewaiver == '0' " >
      <b-form-radio-group id="radio-group-2" v-model="playerSelected" name="plain-inline" class="playerSpectator" plain>
        <b-form-radio value="yes">Player</b-form-radio>
        <br>
        <b-form-radio value="no">Spectator or Chaperone <span style="text-transform:italic;">(Attending but not playing)</span></b-form-radio>
        <br>
        <b-form-radio value="no">Parent or Guardian of a minor <span style="text-transform:italic;">(Not attending)</span></b-form-radio>
      </b-form-radio-group>
    </b-form-group> -->

    <b-form-group v-if="onlinewaiver == '1'" id="input-group-1" class="nameTitle" label-for="input-1">In what capacity are you filling out this waiver?</b-form-group>
    <!-- <b-form-group id="areYouPlayerDiv" > -->
      <!-- <b-form-radio-group id="radio-group-2" v-model="playerSelected" name="plain-inline" class="playerSpectator" plain>
        <b-form-radio value="yes">Player</b-form-radio>
        <br>
        <b-form-radio value="no">Spectator or Chaperone <span style="text-transform:italic;">(Attending but not playing)</span></b-form-radio>
        <br>
        <b-form-radio value="no">Parent or Guardian of a minor <span style="text-transform:italic;">(Not attending)</span></b-form-radio>
      </b-form-radio-group> -->

      <!-- <b-form-group id="areYouPlayerDiv"> -->
        <b-form-group v-if="onlinewaiver == '1'" id="input-group-1" style="text-align:left;">
          <div style="width:50%;margin-left:21%;">
            <b-form-radio v-model="playerSelected" :aria-describedby="ariaDescribedby" name="plain-inline" plain value="yes">Player</b-form-radio>
            <b-form-radio v-model="playerSelected" :aria-describedby="ariaDescribedby" name="plain-inline" plain value="no">
              Spectator or Chaperone (Attending but not playing)
            </b-form-radio>
            <b-form-radio v-model="playerSelected" :aria-describedby="ariaDescribedby" name="plain-inline" plain value="no2">
              Parent or Guardian of a Minor (Not attending)
            </b-form-radio>
          </div>
        </b-form-group>

        <!-- </b-form-group> -->

      </b-form>

      <br><br>

      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <b-button variant="outline-primary" v-on:click="fullnameDiv = !fullnameDiv, emailPhone = !emailPhone" @click="fullNameBackClicked()" >BACK</b-button>
          </b-col>

          <b-col></b-col>

          <b-col>
            <b-button variant="primary" v-on:click="fullnameDiv = !fullnameDiv; emailDiv = !emailDiv; checkZipCode();" v-bind:disabled="isDisableFixedFirstName" >NEXT</b-button>
          </b-col>
        </b-row>
      </b-container>

      <br>

      <div v-if="firstNameDisabled == true || lastNameDisabled == true">
        <p style="font-style:italic;">* If you would like to edit your profile, please email us at info@beatthebomb.com or talk to a Beat The Bomb team member. *</p>
      </div>

      <br> <br>

      <div class="progressBarContainer">
        <div class="progressBarSkills question1">0%</div>
      </div>


  <!-- <div>
    <p style="font-style:italic;"> Question 1 / 7</p>
  </div> -->

  <br>


</div>
<!-- end of full name div -->


<div v-show="!emailDiv">
  <!-- <p>SAN 2</p> -->
  <br><br>
  <b-form-group
  id="input-group-1" class="nameTitle"> Zip Code <span style="color:red; font-style: italic; font-size: 15px;"> ( Required &#42; )</span> 
  <span id="validationError" v-if="zipCodeError == '1'">Please enter a valid zip code.</span>
</b-form-group> 

<b-form-group v-if="zipCodeDisabled == true">
  <b-form-input
  id="inputField"
  v-model="zipCodeInput"
  type="tel"
  required
  placeholder="Enter Zip Code" size="lg" @blur="checkZipCode()" @input="zipCodeEqual5()" disabled>
</b-form-input>
</b-form-group>

<b-form-group v-else>
  <b-form-input
  id="inputField"
  v-model="zipCodeInput"
  type="tel"
  required
  placeholder="Enter Zip Code" size="lg" @blur="checkZipCode()" @input="zipCodeEqual5()">
</b-form-input>
</b-form-group>


<br><br>

<b-form-group
id="input-group-1"
label="Instagram Username"
label-for="input-1" class="nameTitle">
</b-form-group>

<b-form-group class="instagramField">
  <b-input-group prepend="@" size="lg">
    <b-form-input
    id="inline-form-input-name"
    v-model="instagram"
    type="text"
    required
    placeholder="Enter Instagram Handle" class="instagramInput">
  </b-form-input>
</b-input-group>
</b-form-group>
      <!-- <b-form-group id="input-group-1" label-for="input-1" description="Share your handle for a chance to be featured on our official Instagram channel.">
      </b-form-group> -->
      <!-- Share your handle for a chance to be dm’d your photos and video directly. -->
      <b-form-group id="input-group-1" label-for="input-1" description="Share your instagram handle to be featured on our social media channels.">
      </b-form-group>

      <!-- <span style="font-size: 0.8em;">If you don't have one, please enter @bombsquad</span> -->

      <br><br>


      <b-form-group
      id="input-group-1"
      :label="genderNameTitle"
      label-for="input-1" class="nameTitle">

      <b-form-radio-group
      :options="genderoptions"
      v-model="gender_id"
      value-field="genderitem"
      text-field="name" id="genderText"
      >

    </b-form-radio-group>

  </b-form-group>

  <br><br>


  <b-container class="bv-example-row">
    <b-row>
      <b-col>
        <b-button variant="outline-primary" v-on:click="fullnameDiv = !fullnameDiv, emailDiv = !emailDiv">BACK</b-button>
      </b-col>

      <b-col></b-col>

      <b-col>
        <!-- <b-button variant="primary" v-on:click="emailDiv = !emailDiv; genderDiv = !genderDiv; checkPlayerId();" v-bind:disabled="isDisableComputed">NEXT</b-button> -->
        <b-button variant="primary" v-on:click="emailDiv = !emailDiv; hearAboutUsDiv = !hearAboutUsDiv; increaseHeightForInstagram='0';" v-bind:disabled="isDisableComputed">NEXT</b-button>
      </b-col>
    </b-row>
  </b-container>
  <br> <br>

  <div v-if="instagramDisabled == true || zipCodeDisabled == true">
    <p style="font-style:italic;">* If you would like to edit your profile, please email us at info@beatthebomb.com or talk to a Beat The Bomb team member. *</p>
  </div>

  <br><br>

  <div class="progressBarContainer">
    <div class="progressBarSkills question2">15%</div>
  </div>
  <!-- <div>
    <p style="font-style:italic;"> Question 2 / 7</p>
  </div> -->

  <br>


  <div v-if="increaseHeightForInstagram === '1'" style="height: 450px;">
    <p> </p>
  </div>
  <div v-else>
    <p> </p>
  </div>

</div>

<div v-show="!hearAboutUsDiv" id="hearAboutUsDiv">
  <br><br>
  <span id="hearAboutUsTitle">{{ hearAboutUsTitle }}</span>
  <br><br>
  <b-form-radio-group
  v-model="hearAboutUs"
  :options="hearAboutUsOptions"
  class="mb-3"
  value-field="id"
  text-field="answer" v-on:input="surveyAnswerValidation"
  name="radios-stacked"
  stacked
  ></b-form-radio-group>

  <div v-if="hearAboutUs == '6'">
    <span style="color:red; font-size: 0.8em; font-style: italic;" v-if="surveyOtherInput.length < '5' ">Please provide response with minimum 5 characters</span>

    <span style="color:red; font-size: 0.8em; font-style: italic;" v-if="surveyOtherInput.length > '4' "> </span>
    <!-- <b-form-input id="inputField" placeholder="How did you hear about us?" class="mbInputField" v-on:keyup.enter="onClickedGo" v-model="surveyOtherInput" @input="validateOtherHearAboutUs" type="text"></b-form-input> -->
    <b-form-textarea id="textarea" placeholder="How did you hear about us?" class="mbInputField" v-on:keyup.enter="onClickedGo" v-model="surveyOtherInput" @input="validateOtherHearAboutUs" type="text"></b-form-textarea>

  </div>

  <!-- </div> -->

  <br><br>
  <b-container class="bv-example-row" id="hearAboutUsNextButton">
    <b-row>
      <b-col>
        <b-button variant="outline-primary" v-on:click="hearAboutUsDiv = !hearAboutUsDiv, emailDiv = !emailDiv">BACK</b-button>
      </b-col>

      <b-col></b-col>

      <b-col>
        <b-button variant="primary" v-on:click="hearAboutUsDiv = !hearAboutUsDiv; minorsAddDiv = !minorsAddDiv; checkBookerId();" v-bind:disabled="validateHearAboutUs">NEXT</b-button>
        <!-- <b-button variant="primary" v-on:click="hearAboutUsDiv = !hearAboutUsDiv; minorsAddDiv = !minorsAddDiv; checkBookerId();">NEXT</b-button> -->

      </b-col>
    </b-row>
  </b-container>

  <br><br><br>
  <div class="progressBarContainer" style="margin-left: 20%;width:35%;">
    <div class="progressBarSkills question4">45%</div>
  </div>
            <!-- <div style="margin-left:30%;">
              <p style="font-style:italic;"> Question 4 / 7</p>
            </div> -->

            <div v-if="increaseHeightForInstagram === '1'" style="height: 450px;">
              <p> </p>
            </div>
            <div v-else>
              <p> </p>
            </div>

            <br><br>

          </div>

  <!-- <div v-show="!getAtBtbDiv" id="hearAboutUsDiv">
    <br><br>

    <table class="table">
      <tr>
        <td style="border: none;">
          <p style="margin-left: -1.7%;font-size:20px;">What Zip Code did you come from today? (If non-US please write your country of residence.)</p></td>
      </tr>
      <tr>
        <span style="color:red; font-size: 0.8em; font-style: italic;" v-if="zipCodeError == '1'">Zip Code should be atleast 5 digits.</span>

        <b-form-input id="input" placeholder="Zip Code" class="mbInputField" v-on:keyup.enter="onClickedGo" v-model="zipCodeInput" @input="validateFunctionGetAtBtb($event)" type="text" style="width: 30%;"></b-form-input>
      </tr>
    </table>
    
    <br><br>
    <span id="hearAboutUsTitle">{{ getAtBtbTitle }}</span>
    <br><br>
                <b-form-radio-group
                  v-model="getAtBtb"
                  :options="getAtBtbOptions"
                  class="mb-3"
                  value-field="id"
                  text-field="answer" v-on:input="validateFunctionGetAtBtb($event)"
                    name="radios-stacked2"
                    stacked
                ></b-form-radio-group>

                <div v-if="getAtBtb == '16'" style="margin-top: -1%;">
                    <b-form-radio-group style="margin-left: 3%;"
                      v-model="surveyParkCarInput"
                      :options="getParkingOptions"
                      class="mb-3"
                      value-field="id"
                      text-field="parkingAnswer" v-on:input="validateFunctionGetAtBtb($event)"
                        name="radios-stacked3"
                        stacked
                    ></b-form-radio-group>
                </div>
              <br><br>
            <b-container class="bv-example-row" id="hearAboutUsNextButton">
              <b-row>
                <b-col>
                  <b-button variant="outline-primary" v-on:click="hearAboutUsDiv = !hearAboutUsDiv, getAtBtbDiv = !getAtBtbDiv">BACK</b-button>
                </b-col>

                <b-col></b-col>

                <b-col>
                  <b-button variant="primary" v-on:click="getAtBtbDiv = !getAtBtbDiv; minorsAddDiv = !minorsAddDiv;" v-bind:disabled="validateGetAtBtb">NEXT</b-button>

                </b-col>
              </b-row>
            </b-container>

    <br><br>

  </div> -->


  <div v-show="!minorsAddDiv">

    <br><br>

    <span id="minorNameTitle">{{ minorNameTitle }}</span>

    <br><br>

    <b-form-radio-group v-model="minorsChecked" :options="optionsSelectedNo" class="mb-3" value-field="item" text-field="name" v-on:change="validateMinorFieldFunction">

    </b-form-radio-group>

    <div v-show="minorsChecked  === 'A' " >
      <br>
      <p id="minorCheckedText"> Minors should be between 8 and 18 years old </p>
      <br>
      <div class="work-experiences">

        <div class="form-row" v-for="(minordatabase, index) in minorsDetail" :key="index" id="addMinorForm">

          <div class="col-md-2" id="minorNameDiv">
           <label id="minorHeading">Is this minor a player ?</label>
           <br>
            <!-- <b-form-checkbox id="checkbox-index" v-model="minordatabase.minorPlayerOrNot" name="checkbox-index" value="yes" unchecked-value="no">
            </b-form-checkbox> -->
            <input type="checkbox" id="minorPlayerCheckBox" v-model="minordatabase.minorPlayerOrNot" true-value="1" false-value="0" @input="validationByPlayerMinor">
            <!-- </b-form-group> -->
          </div>

          <div class="col-md-2" style="margin-left: 0%;">

            <label id="minorHeading">First Name</label>
            <input v-model="minordatabase.first_name" type="text" class="form-control" placeholder="Minors First Name" id="minorFirstName" @input="validationMinorDOBText"/>
          </div>

          <div class="col-md-2">
            <label id="minorHeading">Last Name</label>
            <input v-model="minordatabase.last_name" type="text" class="form-control" placeholder="Minors Last Name" id="minorLastName" @input="validationMinorDOBText"/>
          </div>

          <div class="col-md-4">
            <label id="minorHeadingDOB">Minor's date of birth</label>

            <p v-if="currentDateCompare > minordatabase.date_of_birth && minordatabase.date_of_birth > '0000-00-00' && minordatabase.minorPlayerOrNot == '1' " v-show="!validationMinorDOBTextFalse" style="color: red;">Minor should be under 18</p>
            <p v-if="minordatabase.date_of_birth > minorLessThan8 && minordatabase.minorPlayerOrNot == '1'" v-show="!validationMinorDOBBelow8TextFalse" style="color: red;">Minor should be over 8 year </p>
            
            <dropdown-datepicker display-format="mdy" v-model="minordatabase.date_of_birth" v-bind:min-age="0" @input="validationMinorDOBText" id="dateDefine"></dropdown-datepicker> 

          </div>

          <div class="col-md-2">
            <!-- <button type="button" class="btn btn-outline-info" @click="minorsDetail.splice(index, 1)">Remove Minor</button> -->

            <p v-if="minorsDetail.length > 1" id="trashCan"><b-icon icon="trash-fill" font-scale="1.5"  @click="removeExperience($event,index)"></b-icon></p>
            <p v-else></p>
          </div>


        </div>

      </div>

      <br>

      <div class="form-group">
        <button @click="addExperience" type="button" class="btn btn-info" style="margin-right:1.5%;" v-bind:disabled="disableAddMinorButton">Add Another Minor</button>
      </div>

    </div>

    <div v-show="minorsChecked  === 'B' ">

    </div>

    <br><br>

    <b-container class="bv-example-row">
      <b-row>
        <b-col>
          <b-button variant="outline-primary" v-on:click="minorsAddDiv = !minorsAddDiv, hearAboutUsDiv = !hearAboutUsDiv">BACK</b-button>
        </b-col>

        <b-col></b-col>

        <b-col>
          <b-button v-if="minorsChecked == null" variant="btn btn-primary" @click="minorModal();">NEXT</b-button>
          <b-button variant="primary" v-else v-on:click=" minorsignDiv = !minorsignDiv; minorsAddDiv = !minorsAddDiv; checkLastPeopleId();
          postReservationData(); increaseHeightForInstagram='0';" v-bind:disabled="validateMinorField">NEXT</b-button>
          <!-- <b-button variant="primary" v-else v-on:click=" covidWholeForm = !covidWholeForm; minorsAddDiv = !minorsAddDiv; postReservationData();" v-bind:disabled="validateMinorField">NEXT</b-button> -->
        </b-col>
      </b-row>
    </b-container>

    <br><br><br>
    <div class="progressBarContainer">
      <div class="progressBarSkills question5">60%</div>
    </div>
            <!-- <div>
              <p style="font-style:italic;"> Question 5 / 7</p>
            </div> -->

            <div v-if="increaseHeightForInstagram === '1'" style="height: 450px;">
              <p> </p>
            </div>
            <div v-else>
              <p> </p>
            </div>

            <br/>

          </div>

          <!-- div for COVID FORM PAGE -->

<!--           <div v-show="!covidWholeForm">

            <span id="hearAboutUsTitle">COVID-19 Attestation</span>

            <br/><br/><br/>

            <div style="width: 92%; margin-left: 4%;">

              <div class="custom-control-lg custom-control custom-checkbox">

                <div id="defineWidthCovid3">
                  <input type="checkbox" class="custom-control-input" id="checkbox-1" v-model="covidForm1" value="1" unchecked-value="not_accepted">
                  <label class="custom-control-label" for="checkbox-1"><b>I confirm I am not experiencing any of the following symptoms of COVID-19 that are listed below:</b></label>
                </div>
                <div id="covidFormListingDiv" style="text-align: left;">
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>&#8226; Fever or chills</b-col>
                      <b-col>&#8226; Muscle or body aches</b-col>
                      <b-col>&#8226; Congestion or runny nose</b-col>
                    </b-row>
                  </b-container>

                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>&#8226; Cough</b-col>
                      <b-col>&#8226; Headache</b-col>
                      <b-col>&#8226; Nausea or vomiting</b-col>
                    </b-row>
                  </b-container>

                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>&#8226; Shortness of breath or difficulty breathing</b-col>
                      <b-col>&#8226; New loss of taste or smell</b-col>
                      <b-col>&#8226; Diarrhea</b-col>
                    </b-row>
                  </b-container>

                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>&#8226; Fatigue</b-col>
                      <b-col>&#8226; Sore throat</b-col>
                      <b-col></b-col>
                    </b-row>
                  </b-container>

                </div>
              </div>

              <br>

              <div class="custom-control-lg custom-control custom-checkbox">

                <div  id="defineWidthCovid3">
                  <input type="checkbox" class="custom-control-input" id="checkbox-2" v-model="covidForm2" value="1" unchecked-value="not_accepted">
                  <label class="custom-control-label" for="checkbox-2">
                    <b>
                      I confirm that in the last 14 days I have not been in contact with anyone who has tested positive for COVID-19 or has experienced the following symptoms of COVID-19 that are listed below:
                    </b>
                  </label>
                </div>

         <div id="covidFormListingDiv" style="text-align: left;">
          <b-container class="bv-example-row">
            <b-row>
              <b-col>&#8226; Fever or chills</b-col>
              <b-col>&#8226; Muscle or body aches</b-col>
              <b-col>&#8226; Congestion or runny nose</b-col>
            </b-row>
          </b-container>

          <b-container class="bv-example-row">
            <b-row>
              <b-col>&#8226; Cough</b-col>
              <b-col>&#8226; Headache</b-col>
              <b-col>&#8226; Nausea or vomiting</b-col>
            </b-row>
          </b-container>

          <b-container class="bv-example-row">
            <b-row>
              <b-col>&#8226; Shortness of breath or difficulty breathing</b-col>
              <b-col>&#8226; New loss of taste or smell</b-col>
              <b-col>&#8226; Diarrhea</b-col>
            </b-row>
          </b-container>

          <b-container class="bv-example-row">
            <b-row>
              <b-col>&#8226; Fatigue</b-col>
              <b-col>&#8226; Sore throat</b-col>
              <b-col></b-col>
            </b-row>
          </b-container>

        </div>
      </div>
      

      <br>


      <br>

      <div class="custom-control-lg custom-control custom-checkbox" id="defineWidthCovid3">
        <input type="checkbox" class="custom-control-input" id="checkbox-3" v-model="covidForm3" value="1" unchecked-value="not_accepted">
        <label class="custom-control-label" for="checkbox-3"><b>I understand travel increases my risk of contracting and transmitting the COVID-19 virus. I verify that I have NOT in the past 14 days traveled: </b></label>
        <p class="covidText" style="text-align: left;">
          1) Outside of the United States to countries that have been affected by COVID-19; or 
          <br>
          2) Domestically within the United States to any states that currently fall under Executive Order 205: Quarantine Restrictions on Travelers Arriving in New York.
        </p>
      </div>

      <br>

      <div class="custom-control-lg custom-control custom-checkbox " id="defineWidthCovid3">
        <input type="checkbox" class="custom-control-input" id="checkbox-4" v-model="covidForm4" value="1" unchecked-value="not_accepted">
        <label class="custom-control-label" for="checkbox-4"><b>I am informed that Beat The Bomb has  implemented preventative measures intended to reduce the spread of COVID-19. However, I understand that by entering Beat the Bomb's premises or participating in any activity there on, I am knowingly and willingly exposing myself to infectious and communicable diseases, including but not limited to severe acute respiratory syndrome coronavirus 2 (commonly known as COVID-19 or corona virus), and that my presence or participation in any activity on BEAT THE BOMB’s premises could increase my risk of contracting such diseases.</b> </label>
      </div>

      <br>

      <div class="custom-control-lg custom-control custom-checkbox" id="defineWidthCovid3">
        <input type="checkbox" class="custom-control-input" id="checkbox-5" v-model="covidForm5" value="1" unchecked-value="not_accepted">
        <label class="custom-control-label" for="checkbox-5"><b>I HAVE READ THE ABOVE CONSENT  FORM AND RELEASE AND BY ACKNOWLEDGING IT I AGREE IT IS MY INTENTION TO EXEMPT AND RELIEVE TASK FORCE ZERO LLC FROM FROM ALL CLAIMS OR BODILY INJURY RESULTING FROM PARTICIPANT’S  EXPOSURE  TO  ANY  BACTERIA,  FUNGUS,  VIRUS,  UNKNOWN  CONTAGIOUS  DISEASES  OR  COVID-19 AND IN ANY WAY CONNECTED TO PARTICIPANT’S ENTRY INTO THE PREMISES OR ENGAGEMENT IN THE ACTIVITIES. </b></label>
      </div>

      <br>
    </div>



    <div id="covidForm2">

      <b-form-group>

       <p style="font-style:italic; color: red; font-size: 1.0em; margin-left: 2%;"> **PLEASE CHECK MARK ALL THE FIELD ABOVE THEN ONLY YOU CAN MOVE ONTO NEXT PAGE.** </p>

     </b-form-group>

   </div>

   <br><br>

   <b-container class="bv-example-row">
    <b-row>
      <b-col>
        <b-button variant="outline-primary" v-on:click="minorsAddDiv = !minorsAddDiv, covidWholeForm = !covidWholeForm">BACK</b-button>
      </b-col>

      <b-col></b-col>

      <b-col>
        <b-button variant="primary" v-on:click="minorsignDiv = !minorsignDiv; covidWholeForm = !covidWholeForm; checkLastPeopleId();increaseHeightForInstagram = '0'" v-bind:disabled="isDisableCovidForm" >NEXT</b-button>

      </b-col>
    </b-row>
  </b-container>

  <br><br>
  <div class="progressBarContainer">
    <div class="progressBarSkills question6">75%</div>
  </div>

            <div v-if="increaseHeightForInstagram === '1'" style="height: 450px;">
              <p> </p>
            </div>
            <div v-else>
              <p> </p>
            </div>


          </div> -->

          <!-- END OF DIV for COVID FORM -->


          <div v-show="!minorsignDiv">

           <br><br>


           <div>
            <b-button v-b-modal.modal-scrollable variant="info">View Full Waiver</b-button>

            <b-modal id="modal-scrollable" scrollable title="Beat The Bomb Waiver" v-bind:hide-footer="true">
              <p class="my-4">
                {{ waiverParagraph1 }}
              </p>

              <p class="my-4">
                {{ waiverParagraph2 }}
              </p>

              <p class="my-4">
                {{ waiverParagraph3 }}
              </p>

              <!-- <p class="my-4">
                {{ waiverParagraph4 }}
              </p> -->

              <!-- <p class="my-4">
                {{ waiverParagraph5 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph6 }}
              </p> -->
              <!-- <p class="my-4">
                {{ waiverParagraph7 }}
              </p> -->
              <p class="my-4">
                {{ waiverParagraph8 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph9 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph10 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph11 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph12 }}
              </p>
              <p class="my-4">
                {{ waiverParagraph13 }}
              </p>

              <!-- <p> -->
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0 custom-control-lg custom-control custom-checkbox" v-model="acceptedCheckBox" :value="1" v-on:change="acceptedWaiverCheckbox"> <b> <!-- I HAVE READ THE ABOVE WAIVER AND RELEASE AND BY SIGNING IT AGREE IT IS MY INTENTION TO EXEMPT AND RELIEVE TASK FORCE ZERO LLC FROM LIABILITY FOR PERSONAL INJURY, PROPERTY DAMAGE AND/OR WRONGFUL DEATH CAUSED BY NEGLIGENCE AND/OR ANY OTHER CAUSE.  -->
                  I have read the above waiver and release and by signing it agree it is my intention to exempt and relieve Task Force Zero LLC from liability for personal injury, property damage and/or wrongful death caused by negligence and/or any other cause.
                </b></b-form-checkbox>
                <!-- </p> -->

                <br>

                <footer id="modal-scrollable___BV_modal_footer_" class="modal-footer">

                  <button type="button" class="btn btn-primary" v-bind:disabled="disabledAgreeButton" v-on:click="clickedOkonWaiver(); submitMinorForm();peopleProfileActive();" @click="$bvModal.hide('modal-scrollable')" >OK</button>

                </footer>



              </b-modal>
            </div>

            <br>
            <span style="font-size: 1.3em;">{{ signDivTitle }}</span>
            <br>


            <div class="container" v-show="!displaySignaturePad">

              <div class="col-12 mt-2">
                <VueSignaturePad
                id="signature"
                ref="signaturePad"
                :options="{onBegin, onEnd, signatureoptions}" v-show="showSignaturePad" class="signatureClass"/>
              </div>
              <br>
              <div class="col-6">
                <button class="btn btn-outline-secondary" @click="undo">Clear Signature</button>
              </div>
      <!-- <div class="col-6 mt-2">
         <button class="btn btn-outline-primary" @click="save">Save</button> 
       </div> -->
     </div>

     <br><br>

     <input col="6" type="hidden" disabled="true" v-model="randomNumber"/>

     <br>

     <!-- modal defined to pass value on mutiple database -->
     <b-modal id="modal-1" ref="my-modal-submit-id" centered v-bind:hide-footer="true" title="Submit Waiver">
      <!-- <p> Please click on submit to complete this waiver. If you want to go through your waiver again, please click on cross sign on top right. </p> -->
      <p> Please click SUBMIT to complete this waiver. </p>
      <!-- <b-button variant="primary" v-on:click="minorsignDiv = !minorsignDiv ; waiverSubmitted = !waiverSubmitted; hideModal(); clickedTimer(); submitReservationMinor(); submitToKlaviyo();">SUBMIT</b-button> -->

      <b-button variant="primary" v-on:click="minorsignDiv = !minorsignDiv ; waiverSubmitted = !waiverSubmitted; hideModal(); clickedTimer(); submitReservationMinor(); submitToKlaviyo(); klaviyoOnlinePreGameEvent(); reloadfunction();">SUBMIT</b-button>
      
      <!-- <b-button variant="primary" v-on:click="minorsignDiv = !minorsignDiv ; waiverSubmitted = !waiverSubmitted; hideModal(); clickedTimer(); submitReservationMinor();">SUBMIT</b-button> -->

    </b-modal>

    <b-container class="bv-example-row">
      <b-row>
        <b-col>
          <!-- <b-button variant="outline-primary" v-on:click="covidWholeForm = !covidWholeForm, minorsignDiv = !minorsignDiv">BACK</b-button> -->
          <b-button variant="outline-primary" v-on:click="minorsAddDiv = !minorsAddDiv, minorsignDiv = !minorsignDiv">BACK</b-button>
        </b-col>

        <b-col></b-col>

        <b-col>

          <!-- <b-button variant="primary" v-b-modal.modal-1 v-on:click="checkLastPeopleId(); checkBookerId(); checkWaiverId(); checkReservationId(); checkPeopleId(); submitPlayerForm();">NEXT</b-button> -->
          <!-- <b-button variant="primary" v-b-modal.modal-1 v-on:click="checkLastPeopleId(); checkWaiverId(); checkReservationId(); checkPeopleId(); submitPlayerForm();">NEXT</b-button> -->

          <b-button variant="secondary" disabled v-if="disabledNextButtonAtLast == true">NEXT</b-button>
          <b-button variant="primary" v-if="disabledNextButtonAtLast == false" v-b-modal.modal-1 @click="save">NEXT</b-button>


        </b-col>
      </b-row>
    </b-container>

    <br> <br>

    <div class="progressBarContainer">
      <div class="progressBarSkills question7">90%</div>
    </div>
            <!-- <div>
              <p style="font-style:italic;"> Question 7 / 7</p>
            </div> -->

            <div v-if="increaseHeightForInstagram === '1'" style="height: 450px;">
              <p> </p>
            </div>
            <div v-else>
              <p> </p>
            </div>

            <div v-if="increaseHeightForInstagram === '1'" style="height: 300px;">
              <p> </p>
            </div>
            <div v-else>
              <p> </p>
            </div>

          </div>

          <!-- this div will be displayed if the waiver was not sign online -->
          <div v-show="!waiverSubmitted" class="waiverSubmittedClass" v-if="onlinewaiver != '1' ">

           <span> Thank you for completing the waiver.<br><br>

            When your team has all completed their waivers, please return to the front desk to finalize payment.

            <br/><br/>

          This app will reset in {{countdownTimer}} seconds. </span>

          <br/> <br/>
        </div>

        <!-- this div will be displayed if the waiver is signed online -->
        <div v-show="!waiverSubmitted" class="waiverSubmittedClass" v-if="onlinewaiver == '1' ">
         <span> Thank you for completing the waiver.<br><br>
          Please arrive 15 minutes before your reservation time.
          <br/><br/>
        This app will reset in {{countdownTimer}} seconds. </span>
        <br/> <br/>
      </div>






      <!-- the below div closed the APP div -->
    </div>
  </template>


  <script src="moment.js"></script>
  <script>
  moment().format();
  </script>

  <script src="../dist/vue-date-dropdown.min.js"></script>
  <script src="./assets/vuedatedropdown.js"></script>
  <script src="vue.js"></script>
  <script src="https://unpkg.com/axios/dist/axios.min.js"></script>

  <!-- script below is for the klaviyo connection -->
  <script type="application/javascript" async src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Q8Ns4x"></script>



  <script>
  // import HelloWorld from './components/HelloWorld.vue'
  // import BookingName from './components/HelloWorld.vue'
  import phone from 'phone';
  import axios from 'axios';
  import VueSignature from "vue-signature-pad";
  // import App from "./App";
  import Vue from 'vue';
  import moment from 'moment';
  import DateDropdown from 'vue-date-dropdown'; // this for the date dropdown
  import DropdownDatepicker from 'vue-dropdown-datepicker';

  import Meta from "vue-meta"; /** metapart is used to disable the zoom in function on safari browser **/

  // import LoadingScreen from "./components/LoadingScreen";


  Vue.use(VueSignature);
  Vue.config.productionTip = false;

  // Vue.use(DateDropdown);
  Vue.use(DropdownDatepicker);

  Vue.use(Meta);

  export default {
    name: 'App',
    components: {
      // HelloWorld,
      // BookingName
      DateDropdown,
      DropdownDatepicker
    },

    metaInfo() {
      return {
        title: "BTB WAIVER",
        meta: [
        {
          vmid: "description",
          name: "description",
          content:
          "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"
        }
        ]
      };
    },

    filters:{
      convertDob(dob){
        if(dob > '0'){
          var birth_date = dob.substring(0,4);
          var getLastDigit = dob.slice(-5);
          // console.log(this.profileDetail[index].date_of_birth);
          return getLastDigit+'-****';
        }
        else{
          return 'N/A';
        }
        
      },

      convertPhone(phone){
        if(phone != null){
          if(phone.length > '0'){
            var phone_number = "***-***-"+phone.substr(phone.length - 4);
            return phone_number;
          }
          else{
            return "N/A";
          }
        }
        else{
          return 'N/A';
        }
      },

    },

    computed: {

      uniqueNames: function() {
        console.log("Received details by name");

        var filtered_array = [];
          // console.log(filtered_array);
          for(var i =0; i < this.reservationBookingsTime.length; i++) {

            var fetchedTime = this.reservationBookingsTime[i].reservation_for;
            var convertTime = moment(fetchedTime).format("hh:mm A");
            // console.log("fetchedTime "+fetchedTime);
            // console.log("convertTime "+convertTime);
            if(filtered_array.indexOf(convertTime) === -1) {
              // console.log(convertTime);
              filtered_array.push(convertTime)
            }
          }
          return filtered_array;
        },

        validationMinorDOBText(){
          // console.log("Inside MINOR DATE");
          // console.log("INISDE DOB");

          // console.log(this.minorsDetail);
          // console.log(this.minorsDetail.length);

          if(this.minorsChecked == 'A'){ /** if selected they have minors checkbox **/

            this.validateMinorField = true; /** disables the button **/

            for(let i=0; i < this.minorsDetail.length; i++){
            // console.log(i);
            var dob = this.minorsDetail[i].date_of_birth;
            // console.log(dob);
            // console.log(this.currentDateCompare);
            // console.log(this.minorLessThan8);
            // console.log("MINOR"+' '+this.minorsDetail[i].minorPlayerOrNot);
            if(this.minorsDetail[i].minorPlayerOrNot == '1'){
              if(dob < this.currentDateCompare || dob > this.minorLessThan8 || this.minorsDetail[i].first_name < '2' || this.minorsDetail[i].last_name < '2' ){
                // console.log("ERROR MESSAGE");
                this.disableAddMinorButton = true; /** disables the button **/
                this.validateMinorField = true;
                break; /** it breaks the loop to make the button disable when the first case is incorrect and second is correct **/
              }
              else{
                // console.log("CORRECT");
                this.disableAddMinorButton = false; /** enable the button **/
                this.validateMinorField = false;
              }
            }
            else{
                // console.log("only go though name validation");
                if(this.minorsDetail[i].first_name > '1' && this.minorsDetail[i].last_name > '1' && this.minorsDetail[i].date_of_birth > '0000-00-00'){
                  this.disableAddMinorButton = false;  /** enables the button **/
                  this.validateMinorField = false;
                }
                else{
                  this.disableAddMinorButton = true;  /** disables the button **/
                  this.validateMinorField = true;
                  break;
                }

              }

            }
          }
          /** if they will click on no minors this will activate the NEXT button for MINORS ADD DIV PART **/
          else{
            this.validateMinorField = false; /** enables the button **/
          }

        },

        isDisableComputed() {

          var x = !this.reg.test(this.email); /** checks if its the valid email or not and return as TRUE or FALSE **/
      // console.log(x);

      var z = phone(this.phone, {country: 'USA'}); /** formats the value got from npm package phone as +18173602704 **/

      if(this.gender_id > '0' && this.zipCodeError.length > '0' && this.zipCodeError != '1' && this.zipCodeInput.length > '3'){
        // console.log("ENABLE");
        return false;
      }
      else{
        // console.log("DISABLE");
        return true;
      }
    },

    sortedArray: function() {
      // console.log("inside sortedArray");

      // console.log(time.items[0].arrivalTime);
      function compare(a, b) {

        var standardTimeA = moment(a.items[0].arrivalTime, "HHmm").format("HH:mm A");
        var standardTimeB = moment(b.items[0].arrivalTime, "HHmm").format("HH:mm A");

        if(standardTimeA = standardTimeB){
          // console.log("same");
          // console.log(standardTimeA+' '+standardTimeB);
          // return this.allbookings.push(compare);
          let unique = [...new Set(standardTimeA,standardTimeB)];
          // console.log(unique); 
        }
        
        if (standardTimeA < standardTimeB)
          return -1;
        if (standardTimeA > standardTimeB)
          return 1;
        return -1;

      }


      // return this.allbookings.sort(compare);
      return this.allbookings.sort(compare);


      // return this.allbookings.sort((standardTimeA, standardTimeB) => standardTimeA < standardTimeB? -1:1)

    },

    removeDuplicatesTime(){
      console.log("inside duplicates time");
      this.allbookings = [ ...new Set(this.allbookings) ];
    },

    isDisableFixedFirstName(){

      // if(this.validationDOBTextFalse = true){
      //   console.log("CASE TRUE");
      //   return true;
      // }
      // else{
      //   return false;
      // }

      var specialChar = "@";
      if (this.first_name.includes(specialChar) || this.last_name.includes(specialChar) || this.first_name < 1 || this.last_name < 1 || this.validationDOBTextFalse == false || this.date_of_birth.length < '10') {
        return true;
      } 
      else {
        return false;
      }
    },

    isDisableCovidForm(){

    // return false;

    if(this.covidForm1 == '1' && this.covidForm3 == '1' && this.covidForm4 == '1' && this.covidForm5 == '1' && this.covidForm2 == '1'){
      console.log('true');
      return false;
    }
    else{
      return true;
    }
  },

  validateGenderField(){
    return this.gender_id < 1;
  },

  // valiadateHearAboutUs(){
  //   return this.hearAboutUs.length < 1;
  // },

  time: function(){
    return this.date.format('mm:ss');
  }

  // formData(){

  //   return{

  //         first_name: this.first_name
  //         // date_of_birth: this.date_of_birth

  //   }

  // }

},

mounted: function(){

  console.log('Waiver loaded ...');
  console.log(window.location.href);
  console.log('btb online waiver loading');

  console.log(this.$route);
  console.log('san online code v3.2');
  
  var routePara = this.$route.fullPath;
  console.log('route url was '+routePara);

  this.phoneCheckbox = '1'; /** this will make the phone check box true **/
  this.phoneIsChecked = true;

  var newRoutePara = routePara.replace('/#/','');

  /** this part is for the order id to track down as on online form **/
  var urlOrderId = newRoutePara;
  var urlOrderIdLength = newRoutePara.length;
  this.bookerOrderId = urlOrderId;

  if (window.location.href.indexOf("btbbrooklyn") > -1) { /** while testing on local computer make it localhost and for online use btbbrooklyn **/

    this.onlinewaiver = 1; /** activation the online waiver for BOOKER and RESERVATION post **/
    this.reservationTimeDiv = false;

      // console.log('url ordr id was '+urlOrderId);
      console.log('inside waiver site');

      if(urlOrderId.length > '20'){

          // console.log(process.env.VUE_APP_RESERVATIONS+'/xola_order_id/'+urlOrderId);

          axios.get(process.env.VUE_APP_RESERVATIONS+'/xola_order_id/'+urlOrderId)
          .then(response => {
            console.log('found reservation detail');
            console.log(urlOrderId);
            var foundReservationId = response.data.id;
            // console.log(foundReservationId);


            this.fetchOrderDetail = response.data;
            this.bookerresult = response.data;

            console.log(this.bookerresult);


            if(response.data.id > 1 && response.data.booker_id > 1){ /**checks on the booker id as to filter ONLINE BTB GAME RESERVATIONS **/

              console.log('on refresh submit data to klaviyo');

              console.log('received booker and resservation detail');
              // this.fullnameDiv = false;
              this.emailPhone = false;
              this.selectedTime = this.fetchOrderDetail.reservation_for; /** this will pass the value for postReservation() data as selectedTime **/

              // console.log(this.fetchOrderDetail.size);

              this.bookerTravelerId = this.fetchOrderDetail.experience_item_id;
              this.bookerItemId = this.fetchOrderDetail.xola_item_id; /** check if the xola_item_id or not **/
              this.bookerTeamSize = this.fetchOrderDetail.size;
              this.bookerDatabaseTableId = this.fetchOrderDetail.booker_id; /** used on  postReservation loop **/
              this.bookerAmount = this.fetchOrderDetail.final_dollar_amount;

              this.waiverSignedOnline = 0; /** this will be updated to btb database **/
              this.mission_id = this.fetchOrderDetail.mission_id;
              this.bookerReservationId = this.fetchOrderDetail.id;

                // console.log(response.data.booker_id);

                var bookerId = response.data.booker_id;

                /** start of booker detail endpoint **/
                // console.log(process.env.VUE_APP_BOOKERS+'/'+bookerId);

                axios.get(process.env.VUE_APP_BOOKERS+'/'+bookerId)
                .then(response => {
                  this.posts = response.data.data
                  console.log('booker information below');
                  // console.log(response);
                  // console.log(response.data.Person.first_name);
                  // console.log(response.data.Person.last_name);
                  // console.log(response.data.Person.last_name.length);

                  // this.fetchOrderDetail = response.data;

                  var personId = response.data.person_id;

                  /** line changed for online **/
                  this.bookerEmail = response.data.Person.email;
                  this.bookerFirstName = response.data.Person.first_name;
                  this.bookerId = response.data.Person.id;

                  if(response.data.Person.phone != null || response.data.Person.phone != ''){
                    if(response.data.Person.phone > '0'){
                      this.bookerPhone = response.data.Person.phone;
                      // this.phone = response.data.Person.phone;
                    }
                  }
                  
                  if(response.data.Person.last_name.length > 0){
                    console.log('booker length greater than 0');
                    this.bookerLastName = response.data.Person.last_name;
                  }
                  else{
                    console.log('booker length less than 1');
                    this.bookerLastName = ' ';
                  } 
                  this.bookername = this.bookerFirstName+' '+this.bookerLastName;

                })
                .catch(function (error) {
                  console.log(error);
                });

                
                // this.klaviyoOnlinePreGameEvent();


              }
              else{
                console.log('Link you have used might not be correct. Can you please contact us on info@beatthebomb.com');
                this.onlineWarning = false;
              }
            })
          .catch(function (error) { /** this is for the error on reservation detail **/
            console.log(error);
          });

        }/** end of IF for URL check for order id **/

        else{
          console.log('different link used');
          this.onlineWarningJustLink = false;
        }


        axios.get((process.env.VUE_APP_TAGS),{

        })
        .then(response => 
        {
            // console.log(response);
            console.log('Succesfully loaded data for ocassion details');
            this.OccasionOptions = response.data;

            this.OccasionOptions.splice(7,1); /** this removes Non profit team building **/
            this.OccasionOptions.splice(8,1); /** this removes Other Group **/
            this.OccasionOptions.splice(9,1); /** this removes Large Group **/
            this.OccasionOptions.splice(8,1); /** this removes Birthday boy **/
            this.OccasionOptions.splice(8,1); /** this removes Birthday party **/


          })
        .catch(function (error) {
          console.log(error);
        });

      }
      /** END of order id online form **/

      this.showSignaturePad = true;

      const current = new moment().format("hh:mm");
      var quaterMinute = ["15","30","30","45"];


      let next15Minutes = moment().add(15, 'minutes');
      next15Minutes.minutes(Math.floor(next15Minutes.minutes() / 15) * 15);
      this.timeList.push(next15Minutes.format('HHmm'));
   // this.timeList.push(next15Minutes.format('H:mm A'));
   const timetest = next15Minutes;
   const timetest1 = next15Minutes;

   for(let i=0;i<5;i++){

    if(i<1){
          //  let currenttime2 = currentTime;
          timetest1.subtract(15, 'minutes');
          timetest1.minutes(Math.floor(timetest1.minutes() / 15) * 15);
          this.timeList.push(timetest1.format('HHmm'));
            // console.log(this.timeList.push(timetest1.format('Hmm')));
          }
          else{
            timetest.add(15, 'minutes');
            timetest.minutes(Math.floor(timetest.minutes() / 15) * 15);
            this.timeList.push(timetest.format('HHmm'));
          // console.log(this.timeList.push(timetest.format('Hmm')));
        }

      }

      this.timeList = [ ...new Set(this.timeList) ];
     this.timeList.sort(); //this will sort out the time from ascending to descending


     this.momentFirstTime = this.timeList[0];
     this.momentLastTime = this.timeList[4];

     var arrivalDate = moment().format('YYYY-MM-DD');
     var arrivalTime = this.arrivalTime1;

    // console.log(process.env.VUE_APP_XOLA);

    var currentDateForReservation = moment().format("YYYY-MM-DD");
    // console.log(currentdate);


    var startReservationTime = moment().subtract(1, 'hours').format('HH:mm:ss');
    var startReservationDate = moment().subtract(1, 'hours').format('YYYY-MM-DD');

    var endReservationTime = moment().add(1, 'hours').format('HH:mm:ss');
    var endReservationDate = moment().add(1, 'hours').format('YYYY-MM-DD');


    var getStartDateTime = moment().format('HHmm');
     // var startArrivalDate = moment().format('YYYY-MM-DD');

     console.log('get start date time to subtract date/hour was '+getStartDateTime);

     if(getStartDateTime < 200){
      console.log('time was greater than 12:00 AM and less than 2:00 AM . So update on current date.');
      startReservationDate = moment().subtract(1,'days').format('YYYY-MM-DD');
      startReservationTime = '23:00:00';

      /** added endReservationTime and endReservationDate to display booking after 12 AM as well **/
      endReservationTime = '01:00:00'; 
      endReservationDate = moment().format('YYYY-MM-DD');
    }
    else{
      console.log('time was greater than 2:00 AM. So no update on date.');
            // endReservationTime = moment().subtract
          }

          console.log('start reservation date '+startReservationDate);
          console.log('start reservation time '+startReservationTime);

          console.log('end reservation date '+endReservationDate);
          console.log('end reservation time '+endReservationTime);


          axios.get((process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+startReservationDate+"T"+startReservationTime+"/end/"+endReservationDate+"T"+endReservationTime),{

          })
          .then(response => 
          {

            console.log('Received reservation detail');
            this.reservationBookingsTime = response.data;

          }
          )
          .catch(function (error){
            console.log(error);
            console.log("THERE ARE NO BOOKING");
          });

          var surveyid1 = '1';

          axios.get(process.env.VUE_APP_SURVEY+'/'+surveyid1,{

          })
          .then(response => {

            var totalSurvey = response.data.Survey_set_questions[0].Survey_set_question_answer_options.length;

            for(let i=0; i<totalSurvey;i++){

              var answerId = response.data.Survey_set_questions[0].Survey_set_question_answer_options[i].survey_answer_option_id;
              var answerOption = response.data.Survey_set_questions[0].Survey_set_question_answer_options[i].Survey_answer_option.answer;

              let answerDetail = {
                'id': answerId,
                'answer': answerOption
              };

              this.hearAboutUsOptions.push(answerDetail);

              if([i+1] == totalSurvey){ /** this will move the OTHER element from middle to LAST ELEMENT **/

                // console.log('san san san');

                this.hearAboutUsOptions.splice(9,1); /** this removes Jewish Press Ad **/
                this.hearAboutUsOptions.splice(8,1); /** this removes JEWISH Press **/
                this.hearAboutUsOptions.splice(7,1); /** this removes Hamodia **/

                /** comment for the JEWISH PRESS ADD **/
                var others = this.hearAboutUsOptions[4];
                this.hearAboutUsOptions.splice(4,1);
                this.hearAboutUsOptions.splice(6, 0, others);

                /** the code below will display the Jewish Press Add splice(9,1) part before others **/
                  // var others = this.hearAboutUsOptions[4];
                  // var jewishPressAd = this.hearAboutUsOptions[7];
                  // this.hearAboutUsOptions.splice(4,1);
                  // this.hearAboutUsOptions.splice(7, 0, others);
                  // this.hearAboutUsOptions.splice(6,1);
                  // this.hearAboutUsOptions.splice(0, 0, jewishPressAd);
                  /** end of Jewish Press Add display **/
                }

              }

              /** for loop below is for the survey question How did you get at beat the bomb ? or SURVEY QUESTION 2 **/
              var surveyGetAtBtbLength = response.data.Survey_set_questions[1].Survey_set_question_answer_options.length;
              console.log(surveyGetAtBtbLength);

              for(let j=0; j<surveyGetAtBtbLength;j++){

                var answerId2 = response.data.Survey_set_questions[1].Survey_set_question_answer_options[j].survey_answer_option_id;
                var answerOption2 = response.data.Survey_set_questions[1].Survey_set_question_answer_options[j].Survey_answer_option.answer;

                let getAtBtbAnswers = {
                  'id': answerId2,
                  'answer': answerOption2
                };

                this.getAtBtbOptions.push(getAtBtbAnswers);

              }
              /** end of question How did you get at btb **/


              console.log('App survey data Received');
            })
          .catch(function (error) {
            console.log(error);
          });

    // console.log(this.surveyQuestionAnswersList);

    if(this.minorsChecked === 'B'){
      // console.log("enable minor");
      this.validateMinorField = false;
    }

     // axios.get('http://localhost:9090/people/').then(response => {this.playersresult = response.data.slice(-1)});  //this calls at the first

     /** below date conversion is for the MINOR less than 6 year from current date **/
     var minorcurrenttime = moment().format("YYYY-MM-DD");
     var minorLessThan8 = moment(minorcurrenttime).subtract(8, 'years').add(1, 'days').format("YYYY-MM-DD");
     var minorLessThan18 = moment(minorcurrenttime).subtract(18, 'years').format("YYYY-MM-DD");

     this.minorLessThan8 = minorLessThan8;
     this.currentDateCompare = minorLessThan18;

     // console.log(minorcurrenttime);
     // console.log(minorLessThan8);
     // console.log(minorLessThan18);

     /** end of date conversion for MINOR less than 6 **/

     /** add the ocassion options **/
     // console.log(process.env.VUE_APP_TAGS);
     // axios.get((process.env.VUE_APP_TAGS),{

     //      })
     //      .then(response => 
     //      {
     //        console.log(response);
     //        console.log('data for ocassion');
     //        this.OccasionOptions = response.data;

     //        this.OccasionOptions.splice(7,1); /** this removes Non profit team building **/
     //        this.OccasionOptions.splice(8,1); /** this removes Other Group **/
     //        this.OccasionOptions.splice(9,1); /** this removes Large Group **/
     //        this.OccasionOptions.splice(8,1); /** this removes Birthday boy **/
     //        this.OccasionOptions.splice(8,1); /** this removes Birthday party **/


     //      })
     //      .catch(function (error) {
     //        console.log(error);
     //      });
     /** end of ocassion options **/

   },


   data() {
    return {
      // customerName: '',
      allReservationDetail: [], /**fetch all the reservation name for the day **/
      reservationBookingsTime:[], /** fetch the particular reservation by time **/
      currentDateCompare: '',
      minorLessThan8: '',
      ValidateEmailTextFalse: true,
      validatePhoneTextFalse: true,
      validationDOBTextFalse: true,
      validateMinorDOBFalse: true,
      validationMinorDOBTextFalse: false,
      validationMinorDOBBelow8TextFalse: false,
      disableAddMinorButton: true,
      validateFirstNameTextFalse: true,
      validateLastNameTextFalse: true,
      validateHearAboutUs: true,
      validateGetAtBtb: true,
      validateZipCodeButton: true,
      covidWholeForm: true,
      isDisableCovidFormButton: true,
      covidForm1: 0,
      covidForm2: 0,
      covidForm3: 0,
      covidForm4: 0,
      covidForm5: 0,

      getAtBtb:[],
      getAnswerSurvey2Id:'',

      hearAboutUsOptions:[],
      getAtBtbOptions:[],

      /** disable input field for repeated player and booker **/
      firstNameDisabled:'',
      lastNameDisabled: '',
      zipCodeDisabled: '',
      instagramDisabled:'',
      dateOfBirthDisabled:'',

      Occasion:'',
      OccasionOptions:[],
      OccasionSurveyTextField:'',
      validateOccasionOther:true,
      occasionReservationId:'',
      bookerOrNot:'',

      bookerPeopleId:'',
      bookerReservationId:'',

      /** profile integration **/
      emailPhone:true,
      profileDetail:[],
      validateProfileDetailPhone:'',
      profilePhoneDetailVerify:'',
      phoneIncorrectText:false,
      /** end of profile integration **/

      getParkingOptions:[
      {id:1,parkingAnswer:'I parked my car on the street'},
      {id:2,parkingAnswer:'I parked in a paid parking garage'}
      ],

      onBeginValue: 0,

      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

      fetchOrderDetail:[],

      onlinewaiver:'',

      playerMinorIdforReservationMinor:'',
      saveSignatureURL: '',

      displaySignaturePad: true,
      acceptedCheckBox: '',
      disabledAgreeButton: true,
      disabledNextButtonAtLast: true,
      disableViewWaiver: true,

      increaseHeightForInstagram: 0,

      countvalidationminorfunction: 0,

      waiverSignedOnline: 1,

      reservationIdForReservationMinor:'',
      toplayerMinorIdList: '', 
      playerMinorIdList: [], 

      DropdownDatepicker: '',
      text: '',
      value: '',
      context: null,
      arrivalTime1: '',
      selectedTime: '',
      reservationNameDiv: true,
      reservationTimeDiv: true,
      emailDiv: true,
      fullnameDiv: true,
      genderDiv: true,
      minorDiv: true,
      minorsignDiv: true,
      minorsAddDiv: true,
      waiverSubmitted: true,
      hearAboutUsDiv: true,
      getAtBtbDiv: true,
      zipCodeDiv: true,
      allreservationamediv: true,

      onlineWarning: true, /** this warning is used on online waiver only **/
      onlineWarningJustLink: true,

      date: moment(60 * 10 * 1000),
      timerCount: '10',
      // minorsChecked: null,

      validateMinorField: false,

      showSignaturePad: false ,
      allPlayerList: [],
      allReservationList: [],
      // allwaiversList: [],
      surveyOtherInput: '',

      allbookings: [],
      momentFirstTime:'',
      momentLastTime:'',
      people_id: '',

      playerSelected:'yes',

      surveyQuestionAnswersList:[],
      surveylistid:'',
      surveyParkCarInput:'',
      zipCodeInput:'',
      zipCodeError:0,

      bookerArrivalTime: '',
      bookerPhoneWasNull: '',
      bookerEmailWasNull: '',
      // bookerReservationId: '',

      activateProfile:'',

      bookerOrderId:'',
      bookerItemId:'',
      bookername: '',
      bookerId: '',
      bookerTeamSize: '',
      bookerAmount: '',
      bookerTravelerId: '',
      bookerEmail: '',
      bookerExperineceId: '', /** this one is tracked down as for mission id **/
      mission_id: '', /** converts bookerExperineceId into 1,2,3 **/
      // bookerTravelerId: '',
      consistsreservationresult:'',
      consistspeopleresult: '', /* this is to pass people id into booking id */
      // inputBookerId: '',
      bookerFirstName: '',
      bookerLastName: '',
      bookerDatabaseTableId:'',

      displayOcassionText: '',

      reservationDateTime: '',

      minorsChecked: null,
      optionsSelectedNo: [
      { item: 'A', name: 'YES', value: 'A'},
      { item: 'B', name: 'NO', value: 'B'},
      ],

      // email: '',
      firstname: '',
      lastname: '',
      gender: '',
      // instagram: '',
      phone: '',
      hearAboutUs: [],

      greetings: 'Welcome to BEAT THE BOMB',
      reservationTimeTitle: 'Please select your reservation time:',
      // reservationNameTitle: 'Please select name of the person <br> who booked your reservation:',
      reservationNameTitle: 'Please select the name of the person who booked your reservation:',
      genderNameTitle: 'What is your gender ?',
      minorNameTitle: 'Are you signing any minors in to play the game?',
      minorNameTitle1: 'Do you have any minors you are signing a waiver for today?',
      // signDivTitle: 'Please review our waiver and then sign below.',
      signDivTitle : 'Please click to view and sign the full waiver.',
      noBookingTitle: 'No booking name. Please go back and select your booking time.',
      instagramTitle: "Instagram Username ",
      phoneTitle: "Phone number for Team Beat The Bomb Images",
      hearAboutUsTitle: 'Where did you first hear about Beat The Bomb?',
      getAtBtbTitle: 'How did you get to Beat The Bomb today?',
      zipCodeTitle:'What Zip Code did you come from today? (If non-US please write your country of residence.)',
      modalTimeDialog: false,
      modalNameDialog: false,
      randomNumber: "https://btbwaiver/llecnas9841"+Math.floor(Math.random() * 1000000000)+"652602/",
      selectedDate: '',
      months: 'Jan, Feb, Mar, Apr, May, Jun, July, Aug, Sep, Oct, Nov, Dec',
      timeList: [],
      posts: [],
      countdownTimer:'10',

      phoneCheckboxValue:'',
      phoneIsChecked:true,
      marketingMessage:null,

      checkMarketingConsent:true,

      clickedOnBooker:'',
      bookerOrNot:'',
      selected1:'',

      playersresult: [],
      bookerresult: [],
      reservationrresult: [],
      peoplresult: [],
      waiverresult: [],
      playerLastId:  '',
      lastPlayerData: [],
      controlPlayerData: [],
      show: false, // this one is for last submit button to close on click

      lastPeopleDataId:[],
      newPlayerLastId:'',
      waiverIdSinged: '',

      form:{
        email: '',
        name: '',
        firstname: '',
        lastname:'',
        dateofbirth: ''
           // food: ''
         },
         show: true,
         selected: '1',
         // options: [
         // { promotionalitem: 'A', name: 'YES' },
         // { promotionalitem: 'B', name: 'NO' },
         // ],

         genderoptions: [
         {genderitem: '1', name: 'Female'},
         {genderitem: '2', name: 'Male'},
         {genderitem: '3', name: 'Non-binary'},
         {genderitem: '4', name: 'I would prefer not to answer'}
         ],

         signatureoptions:{
          penColor: "black"
        },

        minorsDetail: [
        {
          first_name: "",
          last_name: "",
          date_of_birth: "",
          minorPlayerOrNot: "1"
            // title: "Date of Birth"
          }
          ],

          /* post data to api*/
          last_name:"",
          date_of_birth:"",
          gender_id:"",
          promotional_item:'1',
          instagram:"",
          email:"",
          /* above are items posted for people table*/

          first_name:"",
        // date_of_birth:[],

        file: "",

        // below is the paragraph that represents waiver
        waiverParagraph1: ' Task Force Zero LLC does business as Beat The Bomb and operates Beat The Bomb - Brooklyn. ',
        
        waiverParagraph2: ' In consideration of Task Force Zero LLC allowing me to participate in Beat The Bomb, I understand and acknowledge that risks and dangers exist due to participation in Beat The Bomb. ',

        waiverParagraph3: 'I understand and acknowledge that my participation in Beat The Bomb (and/or my use of any equipment provided) may result in harm to me (including but not limited to): bodily injury, fractures, eye injury, blindness, heat stroke, heart attack, disease strains, partial and/or total paralysis, death or other ailments that could cause serious disability.', 
        // I also understand that by entering Beat the Bomb’s premises or participating in any activity thereon, I am knowingly and willingly exposing myself to infectious and communicable diseases, including but not limited to severe acute respiratory syndrome coronavirus 2 (commonly known as Covid-19 or coronavirus), and that my presence or participation in any activity on Beat the Bomb’s premises could increase my risk of contracting such diseases.',

        waiverParagraph4: 'I confirm I am not experiencing any of the following symptoms of COVID-19: fever or chills, cough, shortness of breath or difficulty breathing, fatigue, Muscle or body aches, headache, new loss of taste or smell, sore throat, congestion or runny nose, nausea or vomiting, diarrhea',

        waiverParagraph5:'I confirm that in the last 14 days I have not  been in contact with anyone who has tested positive for COVID-19 or has experienced the following symptoms of COVID-19 that are listed below: fever or chills, cough, shortness of breath or difficulty breathing, fatigue, Muscle or body aches, headache, new loss of taste or smell, sore throat, congestion or runny nose, nausea or vomiting, diarrhea',

        waiverParagraph6:'I understand travel increases my risk of contracting and transmitting the COVID-19 virus. I verify that I have NOT in the past 14 days traveled: 1) Outside of the United States to countries that have been affected by COVID-19; or 2) Domestically within the United States to any states that currently fall under Executive Order 205: Quarantine Restrictions on Travelers Arriving in New York. ',

        waiverParagraph7: 'I am informed that Beat The Bomb has  implemented preventative measures intended to reduce the spread of COVID-19. However, I understand that by entering Beat the Bomb’s premises or participating in any activity thereon, I am knowingly and willingly exposing myself to infectious and communicable diseases, including but not limited to severe acute respiratory syndrome coronavirus 2 (commonly known as Covid-19 or coronavirus), and that my presence or participation in any activity on Beat the Bomb’s premises could increase my risk of contracting such diseases.',

        waiverParagraph8: 'I understand and acknowledge that such injuries could result from (including but not limited to): traversing back and forth across a laser maze that uses Class IIIa 5mW lasers with a 650nm red wavelength; slips, trips, and/or falls in the facility, including but not limited to slippery floors and/or walls (from water, paint, or other substances), that have no handrails; contact with and/or crashing into other participants (whether due to their or your purposeful, reckless, or negligent behavior); contact with and/or crashes with the walls, floors, large metal columns, or doors of any room; defective or negligently maintained or operated equipment in our facility, and/or equipment that is being used in a manner in which it was never intended to be used; getting blasted by high pressure air canons connected to pipes filled with paint, foam and/or soft foam balls.',

        waiverParagraph9: 'I understand that the above risks and dangers (and resultant harm to me) may be caused by the negligence of the owners, employees, officers or agents of Task Force Zero LLC; the negligence of other participants or onlookers in the experience, by my own negligence, by accidents, or by forces of nature or other causes. These risks and dangers may arise from foreseeable or unforeseeable causes. By my participation in these activities and/or use of equipment, I hereby assume all risks and dangers and all responsibility for any losses and/or damages, whether caused in whole or in part by the negligence or other conduct of the owners, agents, officers, employees of Task Force Zero LLC, or by any other person. ',

        waiverParagraph10: 'I, on behalf of myself, my personal representatives and my heirs, executors, administrators, and assigns, hereby voluntarily agree to release, waive, discharge, hold harmless, defend and indemnify Task Force Zero LLC and its owners, employees, agents, officers, members, promoters, contractors or business partners, from any and every claims, demands, actions or rights of action, of whatsoever kind or nature, either in law or in equity arising from or by reason of any bodily injury, or personal injuries known or unknown, property damage, wrongful death, loss of services, or otherwise, resulting or to arise out of my participation in Beat The Bomb, whether by negligence or non-negligence or from any and all other incidents of harm and /or ill-will.',

        waiverParagraph11: 'I specifically understand that I am releasing, discharging and waiving any claims or actions that I may have presently or in the future for the negligent acts or conduct by the owners, employees, agents, officers, members, promoters, contractors or business partners of Task Force Zero LLC. This waiver also applies to me even if I am not a participant but am instead attending Beat The Bomb as a spectator or bystander.',

        waiverParagraph12: 'Furthermore I hereby give Task Force Zero LLC or any of its assigns or business partners the absolute and irrevocable right and permission with respect to any and all photographs/videos taken of myself, a) to copyright the same in Task Force Zero LLC’s or Beat The Bomb’s name or any other name that Task Force Zero LLC may select; b) to use, re-use, publish and republish the same in whole or in part, separately or in conjunction with other photographs, in any medium now or hereafter known, including on the Internet and any and all social media channels, and for any purpose whatsoever, including (but not by way of limitation) advertising, promotion and trade; I hereby release and discharge Task Force Zero LLC from all and any claims and demands ensuing from or in connection with the use of the photographs/videos, including any and all claims for libel and invasion of privacy. This authorization and release shall inure to the benefit of the legal representatives, licensees, and assigns of Task Force Zero LLC. ',

        waiverParagraph13: 'Finally, for two years after the expiration of this agreement, I waive any and all rights to build, design, develop, or fund, aid, influence, or direct, anyone else to build, design, or develop, without the express written permission and agreement of Task Force Zero LLC, any product or experience, for either commercial or even non-commercial purposes, that is substantially similar in technical design, game mechanics, or experiential elements to Beat The Bomb or aspects of it. This waiver intends to capture all of the constituent Beat The Bomb Missions, with games including but not limited to Hack Attack, Laser Maze, Echo Chamber, Floor Grid, CyberBot, Sequencer, CryptoLaser, Mad Dash, Low Battery or Block Monster. It also includes all of Beat The Bomb’s signature special effects endings, including a paint explosion ending (which concept covers all projectile paint, paint blast, paint canon, or paint bomb experiences) and also a foam ball explosion ending (which concept covers all projectile foam balls combined with a Co2 blast, balls blast, balls cannon or similar experiences). This waiver is meant to provide additional legal protection to Task Force Zero LLC over and above any other protections provided by applicable copyright and trademark laws, out of respect for the investment and effort that it took Task Force Zero LLC develop the Beat The Bomb product and experience, and despite the fact that Beat The Bomb is marketed to and open to the general public.'
      }

    },


    methods:{

      displayOcassionFunction(value){
        // this.displayOcassionText = '1';

        console.log(value);

        if(value == 'yes'){
          this.displayOcassionText = '1';
        }
        else{
          this.displayOcassionText = '0';
          this.bookerOrNot = 'notBooker';
        }
      },

      klaviyoOnlinePreGameEvent() {

        console.log(' Inside klaviyo eventTrigger function ');

        // console.log(this.minorsDetail);
        // console.log(this.minorsDetail.length);

        // console.log(process.env.VUE_APP_PEOPLE+'/klaviyo_event/first_name/'+this.first_name+'/last_name/'+this.last_name+'/email/'+this.email);
        /** below axios point is called to add bomb beater and play count detail on KLAVIYO IRL EVENT **/
        axios.get(process.env.VUE_APP_PEOPLE+'/klaviyo_event/first_name/'+this.first_name+'/last_name/'+this.last_name+'/email/'+this.email,{

        })
        .then(response => {
          console.log('Succesfully loaded players detail data');
          // console.log(response);
          var bomb_beater = response.data[0].Player.bomb_beater;
          var play_count = response.data[0].Player.play_count;

          if(!bomb_beater > '0'){
            bomb_beater = '0';
          }

          if(!play_count > '0'){
            play_count = '0'
          }

          // console.log('bomb beater value was '+bomb_beater);
          // console.log('play count value was '+play_count);

          this.postToIRLOnlineWaiver(bomb_beater,play_count);

        })
        .catch(function (error) {
          console.log(error);
        });
        /** END of KLAVIYO IRL EVENT **/


        
      },


      postToIRLOnlineWaiver(bomb_beater,play_count){

        console.log('inside post to irl online waiver klaviyo');

        // console.log('inside postToIRLOnlineWaiver');
        console.log('bomb beater values was '+bomb_beater);
        console.log('play count value was '+play_count);

        if(this.minorsDetail.length == '1'){

          if(this.minorsDetail[0].first_name.length == null || this.minorsDetail[0].first_name.length == '0'){
            // console.log('Minors detail length was 1 with no value on it');

            var number_of_minors = '0';
          }
          else{
            number_of_minors = '1';
          }
        }
        else{
          number_of_minors = this.minorsDetail.length;
        }


        /** details for location name **/
        if(process.env.VUE_APP_LOCATION_ID == '1'){
          var locationName = 'Brooklyn';
        }

        let email = this.email;
        let mission = this.bookerresult.mission_id;
        let reservationDateTime = this.bookerresult.reservation_for;
        // let date_of_birth = '08-01-1993';
        let date_of_birth = this.date_of_birth;
        let gender = this.gender_id;
        // let number_of_minors = '0';
        let xola_item_id = this.bookerresult.xola_item_id;
        let xola_order_id = this.bookerresult.xola_order_id;
        let location_id = locationName; /** fetch location id from env **/
        // let peopleIdPlayer = this.people_id;


        let reservationDate = moment(reservationDateTime).format('YYYY-MM-DD');
        let reservationTime = moment(reservationDateTime).format('HH:mm A');

        if(gender == '1'){
          gender = 'Female';
        }
        if(gender == '2'){
          gender = 'Male';
        }
        if(gender == '3'){
          gender = 'Non-Binary';
        }
        if(gender == '4'){
          gender = 'Prefer not to Answer';
        }

        /** add occasion details into klaviyo event**/
        if(this.clickedOnBooker=='yes' && this.selected=='booker'){
          console.log('add value of booker into klaviyo');

          if(this.Occasion == '1'){
            var occasionValue = 'Adult Birthday Party';
          }
          if(this.Occasion == '2'){
            occasionValue = 'Kids Birthday Party';
          }
          if(this.Occasion == '3'){
            occasionValue = 'Bachelor/Bachelorette Party';
          }
          if(this.Occasion == '4'){
            occasionValue = 'Date Night';
          }
          if(this.Occasion == '5'){
            occasionValue = 'Friends Outing';
          }
          if(this.Occasion == '6'){
            occasionValue = 'Family Outing';
          }
          if(this.Occasion == '7'){
            occasionValue = 'Corporate Team Building';
          }
          if(this.Occasion == '9'){
            occasionValue = 'Kids Field Trip';
          }
          if(this.Occasion == '18'){
            occasionValue = 'Others';
          }
        }
        else{
          occasionValue = 'Not a booker';
        }

        // console.log(this.minorsDetail);  

        console.log('reservation date '+reservationDate);
        console.log('reservation time '+reservationTime);
        console.log('email '+email);
        console.log('mission '+mission);
        console.log('date_of_birth '+date_of_birth);
        console.log('gender '+gender);
        console.log('number of minors '+number_of_minors);
        console.log('xola item id '+xola_item_id);
        console.log('xola order id '+xola_order_id);
        console.log('location id '+location_id);
        // console.log('people id was '+peopleIdPlayer);
        console.log('bomb beater was '+bomb_beater);
        console.log('play count was '+play_count);


        let dataString = {
          "token": "pk_e82bdbf36b68df491b35621c4a3702eec5",
          "event": "IRL Online Waiver",
          "customer_properties": { "email": email },
          "properties": {
            "mission": mission,
            "reservation_date": reservationDate,
            "reservation_time": reservationTime,
            "date_of_birth": date_of_birth,
            "gender": gender, 
            "number_of_minors": number_of_minors,
            "xola_item_id": xola_item_id,
            "xola_order_id": xola_order_id,
            "location": location_id,
            "bomb_beater": bomb_beater,
            "play_count": play_count,
            "online_waiver": 1,
            "group_type": occasionValue,
          }
        }

        dataString = JSON.stringify(dataString);
        
        const options = {
          method: 'POST',
          headers: { Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ 
            data: dataString
          })
        }
        fetch('https://a.klaviyo.com/api/track', options)
            // .then(console.log(JSON.stringify(options)))
            .then(response => response.json())
            .then(response => console.log(response))
            .catch(err => console.error(err));
    },


          clickedOnBookerDiv(value){
            console.log(value);
            console.log(this.bookerEmail);
            console.log(this.bookerEmail.length);
              if(value == 'no'){
              console.log('no');
              this.bookerOrNot = 'notBooker';
              this.clickedOnBooker = 'no';

              this.displayOcassionText = '0';

              console.log('booker or not '+this.bookerOrNot);

              }
              else{
                console.log('yes');
                this.bookerOrNot = 'booker';
                // this.displayOcassionText = '1';

                console.log('booker or not '+this.bookerOrNot);

                // this.clickedOnBooker = 'yes';

                // var fetchNumber = this.bookerPhone;
                // this.phone = fetchNumber;

                // console.log(this.phone);
                // console.log(this.bookerPhone);

                // if(!this.bookerPhone > '0' || this.bookerPhone == '2125551212'){
                //   console.log('inside if true booker email phone function');
                //   this.bookerPhoneWasNull = '1';
                // }
                // else{
                //   console.log('inside else true booker email phone function');
                //   this.bookerPhoneWasNull = '0';
                // }

              }
            
          },


          fullNameBackClicked(){
            console.log('full name back clicked');
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.phone = '';
            this.firstNameDisabled = false;
            this.lastNameDisabled = false;
            this.zipCodeDisabled = false;
            this.instagramDisabled = false;
            this.dateOfBirthDisabled = false;
            this.bookerOrNot = '';
            this.selected = '';
            this.clickedOnBooker = '';
            this.Occasion = '';
        // this.activateProfile = null;
      },


      clickedOccasion(){
        console.log('clicked');
      },

      minorModal(){
        this.$bvModal.show('modal-minorModal');
      },

      hideMinorModal(){
        this.$bvModal.hide('modal-minorModal');
      },

      confirmBookerModal(){
        console.log('inside confirm booker modal');
        this.$bvModal.show('modal-confirmBookerProfile');
      },

      disableBookerSubmitClicked(){
        this.$bvModal.show('modal-disableBookerSubmitClicked');
      },

      hideDisableBookerSubmitClicked(){
        this.$bvModal.hide('modal-disableBookerSubmitClicked');
      },

      hideBookerProfileCheck(){
        this.bookerOrNot = '0';
        this.$bvModal.hide('modal-confirmBookerProfile');
      },

      confirmProfile(index){

        this.profileClickedIndex = index;
        this.first_name = this.profileDetail[index].first_name;
        this.last_name = this.profileDetail[index].last_name;
        this.date_of_birth = this.profileDetail[index].date_of_birth;
        this.instagram = this.profileDetail[index].instagram;
        this.phone = this.profileDetail[index].phone;
        this.zipCodeInput = this.profileDetail[index].postal_code;
        this.gender_id = this.profileDetail[index].gender_id;
        // this.secureDateOfBirth = '**-**-'+this.date_of_birth.substring(0,4);
        this.secureDateOfBirth = moment(this.date_of_birth).format('MM-DD-****');
        this.secureEmail = "***"+this.email.substr(this.email.length - 12);
        // this.securePhoneNumber = "***-***-"+this.phone.substr(this.phone.length - 4);
        if(this.phone != null){
          if(this.phone.length > '0'){
            this.securePhoneNumber = "***-***-"+this.phone.substr(this.phone.length - 4);
          }
          else{
            this.securePhoneNumber = "N/A";
          }
        }
        else{
          this.securePhoneNumber = "N/A";
        }

        if(this.first_name.length > '1' && this.first_name != null){
          this.firstNameDisabled = true;
        }
        if(this.last_name.length > '1' && this.last_name != null){
          this.lastNameDisabled = true;
        }

        if(this.zipCodeInput > '0'){
          console.log('inside zip code function');
          console.log('zip code was '+this.zipCodeInput);
          if(this.zipCodeInput.length > '1' && this.zipCodeInput != null){
            this.zipCodeDisabled = true;
          }
        }
        else{
          console.log('zip code length not more than 5');
          console.log('zip code was '+this.zipCodeInput);
          this.zipCodeInput='0';
        }

        if(this.instagram.length > '1'){
          this.instagramDisabled = true;
        }

        if(this.date_of_birth.length > '3'){
          this.dateOfBirthDisabled = true;
        }
        
        console.log(this.first_name+' was the first name');

        setTimeout(this.$bvModal.show('modal-confirmProfile'),2500);

        // this.$bvModal.show('modal-confirmProfile');
      },

      hideProfileConfirmation(){
        this.$bvModal.hide('modal-confirmProfile');
      },

      verifyProfile(){
        console.log('inside verify phone number ');

        var index = this.profileClickedIndex;

        this.first_name = this.profileDetail[index].first_name;
        this.last_name = this.profileDetail[index].last_name;
        this.date_of_birth = this.profileDetail[index].date_of_birth;
        this.instagram = this.profileDetail[index].instagram;
        this.phone = this.profileDetail[index].phone;
        this.zipCodeInput = this.profileDetail[index].postal_code;


        this.$bvModal.hide('modal-multipleProfileFound');
        this.$bvModal.hide('modal-confirmProfile');


        this.emailPhone = true; /** this will hide the first email id input field **/

        this.fullnameDiv = false;

      },

      bookerProfileConfirmation(){
        this.first_name = this.bookerFirstName;
        this.last_name = this.bookerLastName;
        this.email = this.bookerEmail;

        if(this.first_name.length > '1' && this.first_name != null){
          this.firstNameDisabled = true;
        }
        if(this.last_name.length > '1' && this.last_name != null){
          this.lastNameDisabled = true;
        }

        this.$bvModal.hide('modal-multipleProfileFound');
        this.$bvModal.hide('modal-confirmBookerProfile');

        this.emailPhone = true; /** this will hide the first email id input field **/
        this.fullnameDiv = false;


        if(this.bookerOrNot == 'booker'){
          if(this.Occasion == '18'){
            console.log('clicked others');
            axios.post(process.env.VUE_APP_RESERVATION_TAGS,{
              reservation_id: this.occasionReservationId,
              tag_id: this.Occasion,
              other: this.OccasionSurveyTextField
            })
            .then(response => {
              console.log(response);
            })
            .catch(function (error) {
              console.log(error);
            });
          }
          else{
            axios.post(process.env.VUE_APP_RESERVATION_TAGS,{
              reservation_id: this.occasionReservationId,
              tag_id: this.Occasion
            })
            .then(response => {
              // console.log(response);
              console.log('Succesfully loaded data for reservation tags endpoints');
            })
            .catch(function (error) {
              console.log(error);
            });
          }
        }
        

      },

      checkZipCode(){

        console.log('inside zip code function');
        console.log(this.zipCodeInput);
        console.log(this.zipCodeInput.length);
        
        if(this.zipCodeInput.length > '1' && this.zipCodeInput > 1){
          if(!/^\d+$/.test(this.zipCodeInput) || this.zipCodeInput.length < '3'){
            console.log('error at 2472');
            this.zipCodeError = '1';
          }
        }
        
        if(/^\d+$/.test(this.zipCodeInput) && this.zipCodeInput.length > '3'){
          console.log('error at 2478');
          this.zipCodeError = '0';
        }

      },

      zipCodeEqual5(){

        console.log('got value 2');
        console.log(zipCodeInput.length);

        if(!/^\d+$/.test(this.zipCodeInput)){
          console.log('it was less than 3');
          this.zipCodeError = '1';
        }

        else{
          console.log('it was 3');

          if(this.zipCodeInput.length > '3'){
            console.log('it was 33');
            this.zipCodeError = '0';
          }
        }

      },

      closeDisableSubmitModal(){
        console.log('disable submit close');
        this.$bvModal.hide('modal-disableSubmitClicked');
      },

      disableSubmitClicked(){
        console.log('disable submit clicked');
        this.$bvModal.show('modal-disableSubmitClicked');
      },

      profileCheck(){

        /** check on the email address and phone from database **/
        axios.get(process.env.VUE_APP_PEOPLE+"/search/email/"+this.email+"/phone/"+this.phone,{
        // axios.get(process.env.VUE_APP_PEOPLE+"/search_email_phone/"+this.email,{

        })
        .then(response => 
        {
          // console.log(response);
          console.log('Succesfully loaded repeated email or phone number used list');
          this.profileDetail = response.data;

          this.phoneInputField = true;

          if(response.data.length > 0){
            console.log('more than 1 players profile matched for that email');

            this.$bvModal.show('modal-multipleProfileFound');

          }
          else{
            console.log('No profile matched');
            console.log('Looks like unique email and phone number');
            this.emailPhone = true; /** this will hide the first email id input field **/
            this.fullnameDiv = false;
          }

        })
        .catch(function (error){
          console.log(error);
        });

      },

      klaviyoEmail: function(){

        var x = !this.reg.test(this.email);

        console.log ( 'x value was '+ x);

        if(x === false){
          console.log('false');
          this.ValidateEmailTextFalse = true;
        }
        else{
          console.log('true');
          this.ValidateEmailTextFalse = false;
        }

      },

      correctEmailSecondTime: function(){

        var x = !this.reg.test(this.email);

        if(x === true){
          this.ValidateEmailTextFalse = true;
        }
      },

      klaviyoSmsConsent: function(){

        console.log('inside klaviyoSmsConsent');
        console.log(this.phoneCheckbox);

        var z = phone(this.phone, {country: 'USA'}); /** formats the value got from npm package phone as +18173602704 **/

        if(!/^[0-9]+$/.test(this.phone)){
          console.log('alphabet');
          this.validatePhoneTextFalse = false;
        }
        else{
          console.log('no alphabet');
          this.validatePhoneTextFalse = true;

          if(this.phone.length > 9){

            if(z.phoneNumber != null){
              console.log('correct number');
              this.validatePhoneTextFalse = true;
            }
            else{
              console.log('incorrect phone number');
              this.validatePhoneTextFalse = false;
            }
          }
        }
      },

      /** this will submit to klaviyo **/
      async submitToKlaviyo(){

        console.log('trying to submit data to klv');

        /** chuck's code **/
        const axios = require("axios");
        const {phone} = require('phone');

        /** this is for the player subscription list **/
        var first_name = this.first_name;
        var last_name = this.last_name;
        var date_of_bith = this.date_of_birth;
        var email = this.email;
        var gender = this.gender;

        var phone_number = this.phone;
        let phone_fix;
        if (phone_number != null) {
          phone_fix = phone(
            `'${phone_number}'`
            );
          phone_fix = phone_fix.phoneNumber
        }

        /** end of var for player subsscription list **/

        var marketingConsentValue = this.checkMarketingConsent;

        if(this.promotional_item == '1'){

          /** add player to klaviyo **/
          var addPlayerKlaviyoList = 'V2URU8';
          let add_player = {
            api_key: "pk_e82bdbf36b68df491b35621c4a3702eec5",
            profiles: [
            {
              first_name: `${first_name}`,
              last_name: `${last_name}`,
              phone_number: `${phone_fix}`,
              email: `${email}`,
              marketing_consent: `${marketingConsentValue}`,
              $consent:["sms"],
              $consent: ["email"], /** this will always be true as for Klaviyo **/
              sms_consent: true
            },
            ],
          };
              // console.log(`Add player as : ${JSON.stringify(add_player)}`);
              try {
                const AddPlayerContent = await axios.post(
                  `${process.env.VUE_APP_KLAVIYO_URL}/api/v2/list/${addPlayerKlaviyoList}/subscribe`,
                  // `https://btbbrooklyn.ddns.net:9090/api/v2/list/${addPlayerKlaviyoList}/subscribe`,
                  add_player
                  );
                // console.log(AddPlayerContent.data);
                // console.log('added to player to klaviyo');
              } catch (err) {
               console.log("Error adding player to klaviyo");
             }
             /** end of player add to klaviyo **/


            // var phone_number = "817-360-";
            var klaviyo_list = "RNHhci";

            /** subscribe player in klaviyo **/

            let sms_payload = {
              api_key: "pk_e82bdbf36b68df491b35621c4a3702eec5",
              profiles: [
              {
                $consent: ["sms"],
                phone_number: `${phone_fix}`,
                sms_consent: true
              },
              ],
            };
            console.log(`SMS payload: ${JSON.stringify(sms_payload)}`);
            try {

              const AddKlaviyoSMSConsent = await axios.post(
                `${process.env.VUE_APP_KLAVIYO_URL}/api/v2/list/${klaviyo_list}/subscribe`,
                // `https://btbbrooklyn.ddns.net:9090/api/v2/list/${klaviyo_list}/subscribe`,
                sms_payload
                );
              console.log('added to klaviyo');

              // console.log('klaviyo url was '+process.env.VUE_APP_KLAVIYO_URL/api/v2/list/klaviyo_list/subscribe);

            } catch (err) {
             console.log("Error adding SMS opt in phone number to klaviyo");
             console.log('klaviyo url was '+process.env.VUE_APP_KLAVIYO_URL/api/v2/list/klaviyo_list/subscribe);

           }

           /** end of player subscription code **/
           
         }
         else{
          // console.log('unchecked for promotional item , no text message');

          /** add player to klaviyo **/
          var addPlayerKlaviyoList = 'V2URU8';
          let add_player = {
            api_key: "pk_e82bdbf36b68df491b35621c4a3702eec5",
            profiles: [
            {
              first_name: `${first_name}`,
              last_name: `${last_name}`,
              phone_number: `${phone_fix}`,
              email: `${email}`,
              marketing_consent: `${marketingConsentValue}`,
              $consent: ["email"], /** this will always be true as for Klaviyo **/
              sms_consent: false
            },
            ],
          };
              // console.log(`Add player as : ${JSON.stringify(add_player)}`);
              try {
                const AddPlayerContent = await axios.post(
                  `${process.env.VUE_APP_KLAVIYO_URL}/api/v2/list/${addPlayerKlaviyoList}/subscribe`,
                  // `https://btbbrooklyn.ddns.net:9090/api/v2/list/${addPlayerKlaviyoList}/subscribe`,
                  add_player
                  );
                // console.log(AddPlayerContent.data);
                // console.log('added to player to klaviyo');
              } catch (err) {
               console.log("Error adding player to klaviyo");
             }
             /** end of player add to klaviyo **/
           }
         },

         marketingConsent(event,num){

          if(this.checkMarketingConsent == true){
          // console.log('value 1');
          this.promotional_item = '1';
        }
        else{
          // console.log('value 0');
          this.promotional_item = '0';
        }
      },

      onClickedGo(){
        // console.log('pressed enter bruh');
        return false;
      },

      validateSignaturePad(){
        console.log("oip");
      },

      clickedOkonWaiver(){
        console.log("clicked ok on waiver");
        this.displaySignaturePad = false;
        this.disableViewWaiver = true;
      },

      acceptedWaiverCheckbox(){
        if(this.acceptedCheckBox == '1'){
          this.disabledAgreeButton = true;
      // this.disabledNextButtonAtLast = true;
      console.log("true");
    }
    else{
      console.log('false');
      this.disabledAgreeButton = false;
      // this.disabledNextButtonAtLast = false;
    }
    // if(this.acceptedCheckBox = 'false'){
    //   this.disabledAgreeButton = true;
    //   console.log('false');
    // }
  },

  validateOtherHearAboutUs(){
    if(this.surveyOtherInput.length > 3){
      this.validateHearAboutUs = false;

    }
    else{
      this.validateHearAboutUs = true;
    }
  },

  validateFunctionGetAtBtb(event){
    // console.log(event);

    this.getAnswerSurvey2Id = event;

    console.log('validate get at btb');
    if(this.getAtBtb > '0' && this.zipCodeInput.length > '4'){

      console.log(this.getAtBtb);
      console.log('inside loop');

      this.validateGetAtBtb = false;
      this.zipCodeError = '0';

      if(this.getAtBtb == '16'){
        this.validateParkInfoInput();
      }
    }
    else{
      console.log('validate get at btb 2');     
      this.validateGetAtBtb = true;
    }

    if(this.zipCodeInput.length < '5' && this.zipCodeInput.length > '3'){
      this.zipCodeError = '1';
    }

    if(this.zipCodeInput.length > '4'){
      this.zipCodeError = '0';
    }
  },

  validateParkInfoInput(){
    if(this.surveyParkCarInput > '0'){
      this.validateGetAtBtb = false;
    }
    else{
      this.validateGetAtBtb = true;
    }
  },

  ocasionAnswerValidation(){
    console.log("inside ocasion validation");
    // if(this.ocasion > 0){
    //   this.validateHearAboutUs = false;
    //   this.increaseHeightForInstagram = '1';
    // }
    // if(this.ocasion == 6){
    //   // console.log("1 7");
    //   this.validateHearAboutUs = true;
    //   this.increaseHeightForInstagram = '1';
    // }
    if(this.Occasion == '18'){

      this.increaseHeightForInstagram = '1';

      if(this.OccasionSurveyTextField.length > '4'){
        this.validateOccasionOther = true;
      }
      else{
        this.validateOccasionOther = false;
      }
    }
    else{
      this.increaseHeightForInstagram = '0';
      this.validateOccasionOther = true;
    }
  },

  vaidateOccasionOtherOption(){
    if(this.OccasionSurveyTextField.length > 4){
      console.log('greater than 3 others');
      // this.Occasion='Other';
      this.validateOccasionOther = true;
      this.increaseHeightForInstagram = '1';
    }
    else{
      console.log('less than 3 others');
      // this.Occasion = '';
      this.validateOccasionOther = false;
      this.increaseHeightForInstagram = '0';
    }
  },

  // validateZipCodeFunction(){
  //   if(this.zipCodeInput.length > '4'){
  //     this.validateZipCodeButton = false;
  //   }
  //   else{
  //     this.validateZipCodeButton = true;
  //   }
  // },

  surveyAnswerValidation(){
    console.log("inside survey validation");
    if(this.hearAboutUs > 0){
      // console.log(" 1 6");
      this.validateHearAboutUs = false;
      this.increaseHeightForInstagram = '1';
    }
    if(this.hearAboutUs == 6){
      // console.log("1 7");
      this.validateHearAboutUs = true;
      this.increaseHeightForInstagram = '1';
    }
  },

  validationEmailText(){
    // console.log("VALIDATION EMAIL TEXT");

    this.increaseHeightForInstagram = '1';

    var specialChar = "@";

    var x = !this.reg.test(this.email);

    if(x === false){
      this.ValidateEmailTextFalse = true;
    }
    else{
      this.ValidateEmailTextFalse = false;
    }

  },

  validateFirstNameText(){
    var z = this.first_name;

    if(!/^[A-Za-z]+$/.test(z) || this.first_name.length < 2){
      // console.log("inside z");
      this.validateFirstNameTextFalse = false;
    }
    else{
      this.validateFirstNameTextFalse = true;
    }
  },

  validateLastNameText(){
    var z = this.last_name;

    if(!/^[A-Za-z]+$/.test(z) || this.last_name.length < 2){
      // console.log("inside z");
      this.validateLastNameTextFalse = false;
    }
    else{
      this.validateLastNameTextFalse = true;
    }
  },

  validationPhoneText(){

    console.log('validation phone text');

    var z = this.phone;

    if(!/^[0-9]+$/.test(z) || this.phone.length < 10){
      // console.log("inside z");
      this.validatePhoneTextFalse = false;
    }
    else{
      this.validatePhoneTextFalse = true;
    }

  },

  validationDOBText(){

    var dob= this.date_of_birth;
    // console.log(dob);
    var today = new Date();
    var birthDate = new Date(dob);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if(age<18){
      console.log("less than 16");
      this.validationDOBTextFalse = false;
    }
    else{
      console.log("greater than 18");
      this.validationDOBTextFalse = true;
    }

  },

  validationByPlayerMinor(){

    // console.log(this.minorsDetail);

    var minorPlayerValue = this.minorsDetail[this.minorsDetail.length-1].minorPlayerOrNot;
    // console.log(minorPlayerValue);

    // console.log("LENGTH"+[this.minorsDetail.length-1]);

    if(this.minorsDetail[this.minorsDetail.length-1].minorPlayerOrNot == "1"){
      console.log("YES");
    }

    if(this.minorsDetail[this.minorsDetail.length-1].minorPlayerOrNot == "0"){
      console.log("NO");
    }

  },


  fromMilTime: function(todo){

      // console.log(todo);
      var militarytime = todo;

      // console.log(todo);

      var standardTimeB = moment(militarytime, "HHmm").format("hh:mm A");
      // [...new Set(a.items[0].arrivalTime)]

      // var removeSameTime = [...new Set(standardTimeB)];

      // console.log(standardTimeB);

       // return changedTime;
       return standardTimeB;
      // return ([...new Set(standardTimeB)]);
    },

    convertArrivalTime(index){
        // console.log(this.bookerArrivalTime);
        // console.log("vitra chirey hai");
        var bookerTimeFetched = this.bookerArrivalTime;
        var character = ":";
        var position = 2;
        
        if(this.reservationDateTime == 0){
          // console.log("it was zero");
          this.reservationDateTime = moment(bookerTimeFetched).add(1,'hour').format("YYYY-MM-DD H:mm:ss");
        }
      },

      sortArrays(sortTime) {
        return _.orderBy(sortTime, 'items.arrivalTime', 'asc');
      },

      checkMissionId(){
        // console.log("print mission id");
        // console.log(this.bookerAmount);
        // console.log(this.bookerExperineceId);
        if(this.bookerExperineceId == "5e2077dfdbc7032265381d36"){
          this.mission_id = 1;
          // console.log(this.mission_id);
        }
        if(this.bookerExperineceId == "5e207a68e86c5039be447ecc"){
          this.mission_id = 2;
          // console.log(this.mission_id);
        }
      },

      clickedTimer(){
        var time = 11;
        var duration = moment.duration(time, "seconds");
        var interval = 1000;

        setInterval(() => {
          duration.subtract(interval, "milliseconds"); //using momentjs substract function
          this.countdownTimer = moment(duration.asMilliseconds()).format('s'); 
          // console.log(moment(duration.asMilliseconds()).format('s'));
        }, interval );

      },

      bookerName(index){

          // console.log(this.posts[index].items[0].experience.id);
          console.log("I WAS INSIDE BOOKER NAME");
          // console.log("INDEX "+index);

          var bookerFirstName = this.posts[index].Booker.Person.first_name;
          var bookerLastName = this.posts[index].Booker.Person.last_name;
          console.log("BOOKER LAST NAME "+bookerLastName);

          if(bookerLastName == 'undefined'){
            console.log("BOOKER LAST NAME WAS NULL");
            var bookerLastName = 'undefined';
          }

          this.bookerFirstName = bookerFirstName;
          this.bookerLastName = bookerLastName;

          this.bookername = bookerFirstName+' '+bookerLastName;
          console.log(this.posts);
          console.log(this.bookername);

          this.occasionReservationId = this.allReservationDetail[index].id;

          this.bookerPeopleId = this.allReservationDetail[index].Booker.Person.id;

          this.bookerId = this.posts[index].xola_booker_id;
          this.bookerTeamSize = this.posts[index].size;
          this.bookerAmount = this.posts[index].final_dollar_amount;
          this.bookerTravelerId = this.posts[index].xola_booker_id;
          this.bookerExperineceId = this.posts[index].experience_item_id;
          this.bookerEmail = this.posts[index].Booker.Person.email;
          this.bookerArrivalTime = this.posts[index].reservation_for;
          this.bookerOrderId = this.posts[index].xola_order_id;
          this.bookerItemId = this.posts[index].xola_item_id;
          this.bookerPhone = this.posts[index].phone;

          this.bookerDatabaseTableId = this.posts[index].Booker.id;
          this.mission_id = this.posts[index].Mission.id;

          // console.log("below booker id = ");
          console.log("BOOKER ID "+this.bookerId);
          console.log("XOLA BOOKER ORDER ID "+this.bookerOrderId);
          console.log("XOLA BOOKER EXPERIENCE ID "+this.bookerExperineceId);
          console.log("XOLA BOOKER ITEM ID "+this.bookerItemId);
          console.log("XOLA BOOKER FULL NAME "+this.bookername);
          console.log("XOLA BOOKER ARRIVAL TIME "+this.bookerArrivalTime);
          console.log('Booker database table id was '+this.bookerDatabaseTableId);

        },

        bookerNameGetHelp(index){

          /** THESE WERE FOR THE XOLA **/

          console.log("BOOKER FULL NAME "+this.bookername);

          /** CALLED FROM OUR DATABASE**/

          console.log("ALL BOOKER NAME INDEX "+index);

          var bookerFirstName = this.allReservationDetail[index].Booker.Person.first_name;
          var bookerLastName = this.allReservationDetail[index].Booker.Person.last_name;
          console.log(bookerFirstName);
          console.log(bookerLastName);
          // console.log("BOOKER LAST NAME "+bookerLastName);

          if(bookerLastName == 'undefined'){
            console.log("BOOKER LAST NAME WAS NULL");
            var bookerLastName = ' ';
          }

          this.bookername = bookerFirstName+' '+bookerLastName;
          this.bookerFirstName = bookerFirstName;
          this.bookerLastName = bookerLastName;
          console.log(this.bookername);

          this.occasionReservationId = this.allReservationDetail[index].id;

          this.bookerPeopleId = this.allReservationDetail[index].Booker.Person.id;

          this.bookerId = this.allReservationDetail[index].Booker.xola_booker_id;
          this.bookerTeamSize = this.allReservationDetail[index].size;
          this.bookerAmount = this.allReservationDetail[index].final_dollar_amount;
          this.bookerTravelerId = this.allReservationDetail[index].Booker.Person.xola_booker_id;
          this.bookerExperineceId = this.allReservationDetail[index].experience_item_id;
          this.bookerEmail = this.allReservationDetail[index].Booker.Person.email;
          this.bookerArrivalTime = this.allReservationDetail[index].reservation_for;
          this.bookerOrderId = this.allReservationDetail[index].xola_order_id;
          this.bookerItemId = this.allReservationDetail[index].xola_item_id;
          this.bookerDatabaseTableId = this.allReservationDetail[index].Booker.id;
          this.bookerPhone = this.allReservationDetail[index].Person.phone;

          // this.bookerAmount = this.allReservationDetail[index].Booker.
          
          this.mission_id = this.allReservationDetail[index].Mission.id;

          // console.log("below booker id = ");
          console.log("BOOKER ID "+this.bookerId);
          console.log("XOLA BOOKER ORDER ID "+this.bookerOrderId);
          console.log("XOLA BOOKER EXPERIENCE ID "+this.bookerExperineceId);
          console.log("XOLA BOOKER ITEM ID "+this.bookerItemId);
          console.log("XOLA BOOKER FULL NAME "+this.bookername);
          console.log("Xola database booker id " +this.bookerDatabaseTableId);
          console.log("Mission id was " +this.mission_id);

          /** END OF ALL BOOKIN FULLTAIL **/

        },


        hideModal() {
          this.$refs['my-modal-submit-id'].hide()
        },

        onSubmit(evt) {
          evt.preventDefault()
          alert(JSON.stringify(this.form))
        },

        onReset(evt) {
          evt.preventDefault()
        // Reset our form values
        this.form.email = ''
        this.form.name = ''
        //this.form.food = null
        this.form.checked = []
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },

      signatureLoad(){
        this.showWithResize();
      },

      showWithResize() {
        this.isShow = true
          // this.$refs.signaturePad.$refs.signaturePadCanvas.width = 250;
          // this.$refs.signaturePad.$refs.signaturePadCanvas.height = 250;
        },


        undo() {
          // this.$refs.signaturePad.undoSignature();
          this.$refs.signaturePad.clearSignature();
          this.disabledNextButtonAtLast = true;
        },

        save() {
          // console.log(" INSIDE SAVEEEEE ");
          const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
          // this.disabledNextButtonAtLast = false;
          console.log('looking data for signature');
          console.log(data);
          this.saveSignatureURL = data;
        },

        change() {
          this.options = {
            penColor: "#00f"
          };
        },

        resume() {
          this.options = {
            penColor: "#c0f"
          };
        },


        onBegin() {
          if(this.onBeginValue == '0'){
            this.$refs.signaturePad.$refs.signaturePadCanvas.width = 500;
            this.$refs.signaturePad.$refs.signaturePadCanvas.height = 300;
            this.onBeginValue = '1';
          }
        },

        onEnd() {
          console.log('End signature');
          if(this.acceptedCheckBox == '1'){
            // console.log('1');
            this.disabledNextButtonAtLast = false;
          }
        },


        addExperience(){
          console.log('inside add experience');

          this.minorsDetail.push({
            first_name: '',
            last_name: '',
            date_of_birth: '',
            minorPlayerOrNot: "1"
          })
          this.validateMinorField = true; /** this will make the NEXT button disabled when they click on ADD ANOTHER MINOR **/
          this.disableAddMinorButton = true; /** this will disable add a minor GREEN BUTTON **/
        },

        removeExperience: function(event,index){

          console.log('INSIDE REMOVE EXPERIENCE');
          // console.log(index);

          // var index = this.minorsDetail.indexOf(todo);
          this.minorsDetail.splice(index, 1);

          // this.removeMinorFieldFunction();

          // console.log(this.minorsDetail.length);

          for (var i = 0; i < this.minorsDetail.length; i++) {

            if(this.minorsDetail[i].date_of_birth > this.currentDateCompare && this.minorsDetail[i].date_of_birth > this.minorLessThan8){
              console.log('inside dob');
              if(this.minorsDetail[i].last_name > '2'){
                console.log('inside l name');
                console.log('last name '+this.minorsDetail[i].last_name);
                if(this.minorsDetail[i].first_name > '2'){
                  console.log('inside f name');
                  this.disableAddMinorButton = false; 
                  this.validateMinorField = false;
                }
                else{
                  this.disableAddMinorButton = true; 
                  this.validateMinorField = true;
                  break;
                }
              }
              else{
                this.validateMinorField = true; /** this will make the NEXT button disabled when they click on ADD ANOTHER MINOR **/
                this.disableAddMinorButton = true; /** this will disable add a minor GREEN BUTTON **/
                break;
              }
            }
            else{
              this.validateMinorField = true; /** this will make the NEXT button disabled when they click on ADD ANOTHER MINOR **/
              this.disableAddMinorButton = true; /** this will disable add a minor GREEN BUTTON **/
              break;
            }

          }
        },

        // validateMinorLastFieldFunction: function(){
        //   var lastminorname = this.minorsDetail[0].last_name;
        //   if(lastminorname.length < 3){
        //       this.validateMinorField = true;
        //     }

        //   if(lastminorname.length > 2){
        //       this.validateMinorField = false;
        //     }
        // },

        validateMinorFieldFunction: function(){

            // console.log(this.minorsDetail);

            // console.log(this.minorsDetail[0].first_name);
            this.validationByPlayerMinor();

            var firstminorname = this.minorsDetail[0].first_name;
            var lastminorname = this.minorsDetail[0].last_name;
            var firstdob = this.minorsDetail[0].date_of_birth;

            // this.validateMinorField = true;

            // if(this.validationMinorDOBTextFalse == true){
            //   console.log("its true");
            //   // this.validateMinorField = true;
            // }
            // else{
            //   console.log("else 77777");
            //   this.validateMinorField = false;
            // }

            if(firstminorname.length > 2 && lastminorname.length > 1 && firstdob.length > 2){
              // console.log("greater than 3 man");
              this.validateMinorField = false;
            }

            if(lastminorname.length > 1){
              // console.log("greater than 3 man");
              this.validateMinorField = false;
            }

            if(this.minorsDetail.length <= 1){
              // console.log("empty");
              console.log(this.minorsDetail.length);
              this.validateMinorField = false;

              if(this.minorsChecked === 'A'){
                console.log("enable minor");
                this.validateMinorField = true;
              }

            }

            else{
              var minordetail = this.minorsDetail;
              var minordetaillength = this.minorsDetail.length;
              console.log(minordetaillength-1);
              this.validateMinorField = true;
              this.disableAddMinorButton = true;

              if(minordetail[minordetaillength-1].first_name.length > 2 && minordetail[minordetaillength-1].last_name.length > 1 && minordetail[minordetaillength-1].date_of_birth.length > 2){
                // console.log("less than 2");
                this.validateMinorField = false;
              }
            }

          },

          removeMinorFieldFunction(){
            // console.log("inside minor function");

            var minordetail = this.minorsDetail;
            var minordetaillength = this.minorsDetail.length;
              // console.log(minordetaillength-1);
              this.validateMinorField = true;

              if(minordetail[minordetaillength-1].first_name.length > 2){
                // console.log("less than 2");
                this.validateMinorField = false;
              }

            },

            submit () {
              const data = {
                minorsDetail: this.minorsDetail
              }
              alert(JSON.stringify(data, null, 2))
          // alert(minordatabase.first_name)
        },

        removeDuplicates () {
          this.timeList = [ ...new Set(this.timeList) ]
        },

        displayAllBookings: function (){

          var arrivalDate = moment().format('YYYY-MM-DD');
          var startArrivalDate = moment().format('YYYY-MM-DD');
          
          /** OUR DATABASE , list all booker name for particular time **/
            // console.log(process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+arrivalDate+"T08:45:00"+"/end/"+arrivalDate+"T23:50:00");
            axios.get(process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+startArrivalDate+"T08:45:00"+"/end/"+arrivalDate+"T23:59:00",{

            })
            .then(response => 
            {
                // console.log(response);
                // console.log(response.data);
                var formatData = response.data;

                console.log(formatData);
                var totalPlayers = response.data.length;

                // for(let i=0; i < totalPlayers;i++){
                //   console.log(formatData[i].Booker.Person.first_name);

                // }

                this.allReservationDetail = response.data;

                function compare(a, b) {
                  if (a.Booker.Person.first_name < b.Booker.Person.first_name)
                    return -1;
                  if (a.Booker.Person.first_name > b.Booker.Person.first_name)
                    return 1;
                  return 0;
                }

                return this.allReservationDetail.sort(compare);

                // console.log(this.allReservationDetail);

                // console.log(response.data.[0]);
              }
              )
            .catch(function (error){
              console.log(error);
            });

            /** END of listing all booker name for particular time **/

          },

          showTheTime: function (){
        // alert(this.selectedTime);
        console.log(event.target.value);
         // console.log(event);
         var standardTimeFormat = event.target.value;
         console.log(event.target.value);

         this.reservationDateTime = standardTimeFormat +' '+ moment(moment.now()).format("YYYY/MM/DD");
         console.log(this.reservationDateTime);

         // console.log(this.reservationDateTime);

         var militaryTimeFormat1 = moment(standardTimeFormat, "h:mm A").subtract(2,"minutes").format("HH:mm:ss");
         var militaryTimeFormat2 = moment(standardTimeFormat, "h:mm A").add(2,"minutes").format("HH:mm:ss");
        // console.log(militaryTimeFormat);

        var arrivalDate = moment().format('YYYY-MM-DD');
      // var arrivalTime = this.militaryTimeFormat;
      // console.log(process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate+"&items.arrivalTime="+militaryTimeFormat);
      
      /** OUR DATABASE , list all booker name for particular time **/
      console.log(process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+arrivalDate+"T"+militaryTimeFormat1+"/end/"+arrivalDate+"T"+militaryTimeFormat2);
      axios.get((process.env.VUE_APP_RESERVATIONS+"/checkin/start/"+arrivalDate+"T"+militaryTimeFormat1+"/end/"+arrivalDate+"T"+militaryTimeFormat2),{

      })
      .then(response => 
      {
            // console.log(response);
            // console.log(response.data);
            this.posts = response.data;
            // console.log(response.data.[0]);
          }
          )
      .catch(function (error){
        console.log(error);
      });

      /** END of listing all booker name for particular time **/


      /** XOLA MAIN **/

      // console.log(process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate+"&items.arrivalTime="+militaryTimeFormat);
      // axios.get((process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate+"&items.arrivalTime="+militaryTimeFormat),{
      //   headers:{
      //       'X-API-KEY': "XLMOMPiQLvfC_saSiKLIld4KPO9DFWrZokjOf9lcVTg",
      //       'X-API-VERSION': "2018-06-26"
      //     },
      // })
      // .then(response => (this.posts = response.data.data));


      /** XOLA SANDBOX **/

      // console.log((process.env.VUE_APP_XOLA+"/api/orders?seller=5e1f43c0c697353cf12979e7&items.arrival="+arrivalDate+"&items.arrivalTime="+militaryTimeFormat));

      // axios.get((process.env.VUE_APP_XOLA+"/api/orders?seller=5e1f43c0c697353cf12979e7&items.arrival="+arrivalDate+"&items.arrivalTime="+militaryTimeFormat),{
      //       headers:{
      //         'X-API-KEY': "Af144hp8uKL3ESKoSDlsDR1btaMM4nO1cbdsT8rWvKo",
      //         // 'X-API-VERSION': "2018-06-26"
      //       },
      //   })
      //  .then(response => (this.posts = response.data.data));


      this.selectedTime = moment(standardTimeFormat, "HHmm").format("YYYY-MM-DD HH:mm:00");
      console.log(this.selectedTime);

      document.getElementById("hideDiv").style.visibility="visible";
      setTimeout("hideDiv",3000);

    },

    reloadfunction(){
      setTimeout(location.reload.bind(location), 9800);
    },



    showAllTime: function (event){

      var arrivalDate = moment().format('YYYY-MM-DD');

      // axios.get(process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate,{headers:{'X-API-KEY':'Af144hp8uKL3ESKoSDlsDR1btaMM4nO1cbdsT8rWvKo'}})

      /** XOLA MAIN **/
      console.log(process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate);
      axios.get((process.env.VUE_APP_XOLA+"/api/orders?seller=599cbd73332e7575198b4575&items.arrival="+arrivalDate),{
        headers:{
          'X-API-KEY': "XLMOMPiQLvfC_saSiKLIld4KPO9DFWrZokjOf9lcVTg",
          'X-API-VERSION': "2018-06-26"
        },
      })

      /** XOLA SANDBOX **/
      // console.log(process.env.VUE_APP_XOLA+"/api/orders?seller=5e1f43c0c697353cf12979e7&items.arrival="+arrivalDate);
      // axios.get((process.env.VUE_APP_XOLA+"/api/orders?seller=5e1f43c0c697353cf12979e7&items.arrival="+arrivalDate),{
      //     headers:{
      //       'X-API-KEY': "Af144hp8uKL3ESKoSDlsDR1btaMM4nO1cbdsT8rWvKo",
      //       // 'X-API-VERSION': "2018-06-26"
      //     },
      // })
      .then(response => (this.posts = response.data.data));

    },


    isDisableFixed(email) {
      return email.length > 5;
    },

    validateInstagram(instagram){
      return text.length > 3;
    },

    validatephone(phone){
      return text.length > 9;
    },

    isDisableFixedFName(firstname) {
      return text.length > 2;
    },

    disableLastName(lastname){
      return text.length > 2;
    },

    validateGender(gender){
      return text.length > 0;
    },


    // valiadateHearAboutUs(hearAboutUs){
    //   return text.length > 0;
    // },

    checkedMinor(){
      $('input.chk').on('change', function() {
        $('input.chk').not(this).prop('checked', false);  
      });
    },

    // checkPlayerId(){

    //   console.log(this.first_name);
    //   console.log(this.last_name);
    //   console.log(this.email);

    //   var email = this.email;
    //   var fname = this.first_name;
    //   var lname = this.last_name;

    //   // /people/find_or_create/email/:email/first_name/:first_name/last_name/:last_name
    //   console.log(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+email+'/first_name/'+fname+'/last_name/'+lname);

    //   axios.get(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+email+'/first_name/'+fname+'/last_name/'+lname)
    //   .then(response => {
    //     console.log(response);
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });


    //     // axios.get(process.env.VUE_APP_PEOPLE).then(response => {
    //     //   this.playersresult = response.data.slice(0);
    //     //   }); // this get id for player_minor table id
    //   },

    checkBookerId(){
        // axios.get(process.env.VUE_APP_BOOKERS).then(response => {
        // console.log("check booker id");
        // this.bookerresult = response.data.slice(-1);

        //     // postWaiverId(){
        //     /** axios post on waiver table **/
        //     axios.post(process.env.VUE_APP_WAIVERS,{
        //       waiver_url : this.randomNumber
        //     })
        //     .then(response => {
        //       console.log("below is waiver id");
        //       console.log(response.data.id);
        //       this.waiverIdSinged = response.data.id;
        //     })
        //     .catch(function (error) {
        //       console.log(error);
        //     });
        // });

        // var selectedBookerId = this.bookerTravelerId;

        // axios.post(process.env.VUE_APP_BOOKERS+'/find_or_create/'+selectedBookerId,{

        // })
        // .then(response => {
        //   console.log(response);
        //   // var fetchedBookerId = response.data[0].id;
        //   this.bookerDatabaseTableId = response.data[0].id;
        // })
        // .catch(function (error) {
        //   console.log(error);
        // });

    }, // this get id for player_minor table id
        // console.log('inside bookers');

        checkReservationId(){
          axios.get(process.env.VUE_APP_RESERVATIONS).then(response => {this.reservationrresult = response.data.slice(-1)}); 
      // console.log('inside reservation');

    },

    // checkWaiverId(){
    //  axios.get(process.env.VUE_APP_WAIVERS).then(response => {this.waiverresult = response.data.slice(-1)});
    // },

    // checkReservationId(){
    //   var reservationOrderId = this.bookerTravelerId;
    //   axios.post(process.env.VUE_APP_RESERVATIONS+'/find_or_create/'+reservationOrderId).then(response => {this.consistsreservationresult = response.data});
    //   // console.log(this.bookerTravelerId);
    // },

    checkPeopleId(){
      var reservationOrderByEmail = this.bookerEmail;
      console.log('checking people id ');
      axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/'+reservationOrderByEmail).then(response => {this.consistspeopleresult = response.data});
      // console.log(this.bookerEmail);
    },

    checkLastPeopleId(){

      console.log("INSIDE CHECK LAST PEOPLE ID");

      //   console.log(this.bookerOrderId);
      //   console.log(process.env.VUE_APP_RESERVATIONS+'/find_or_create/'+reservationOrderId);

      var reservationOrderId = this.bookerOrderId;
      var reservationItemId = this.bookerItemId;
      

      /** this will submit on PEOPLE table **/
      var reservationOrderByEmail = this.bookerEmail;
      var reservationFirstName = this.bookerFirstName;
      var reservationLastName = this.bookerLastName;
      var formEmailUsed = this.email;
      var formFirstName = this.first_name;
      var formLastname = this.last_name;
      var formPhone = this.phone;

      axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+reservationOrderByEmail+'/first_name/'+reservationFirstName+'/last_name/'+reservationLastName,{
        first_name: this.bookerFirstName,
        last_name: this.bookerLastName,
        email: this.bookerEmail
      })
      .then(response => {
        this.consistspeopleresult = response.data;
                // console.log(response.data);
                console.log("reservation name created in people table");

              })
      .catch(function (error) {
        console.log(error);
      });
      /** end of submit **/

      /** SUBMIT PLAYER FORM CODE **/

                // var reservationOrderByEmail = this.bookerEmail;
                axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+formEmailUsed+'/first_name/'+formFirstName+'/last_name/'+formLastname,{
                  date_of_birth: this.date_of_birth,
                  gender_id: this.gender_id,
                  marketing_consent: this.promotional_item,
                  phone: this.phone,
                  email: this.formEmailUsed,
                  instagram: this.instagram,
                  postal_code: this.zipCodeInput,
                  active: '1',
                })
                .then(response => {
                  console.log('posted player detail');
                  // console.log(response);
                  // console.log(response.data[0].id); /** this will return the ID from above which will then update the values **/
                  // console.log("Posted player detail");

                  this.people_id = response.data[0].id;
                  var peopleId = response.data[0].id;
                  /** if the booker is player as well then it will update the values **/
                  // axios.put(process.env.VUE_APP_PEOPLE+'/'+peopleId,{
                  //   date_of_birth: this.date_of_birth,
                  //   gender_id: this.gender_id,
                  //   marketing_consent: this.promotional_item,
                  //   phone: this.phone,
                  //   email: this.formEmailUsed,
                  //   instagram: this.instagram,
                  //   postal_code: this.zipCodeInput,
                  //   active: '1'
                  // })
                  // .then(response => {
                  //     console.log('active profile');
                  //     console.log("Updated player detail with same name and email");
                  //   })
                  // .catch(function(error){
                  //   console.log(error);
                  // });
                  /** end of update for BOOKER as PLAYER **/


                })
                .catch(function (error){
                  console.log(error);
                });

                /** END OF SUBMIT PLAYER FORM CODE **/

              },


              postReservationData(){
      // console.log("Order Id"+this.bookerOrderId);
      var reservationOrderId = this.bookerOrderId;
      var reservationItemId = this.bookerItemId;

      // var checkEmptyBooking = Object.keys(bookerDataId).length;

      // console.log(this.bookerresult[0]);

      /** below IF and ELSE statement is used for NEED A HELP button at first two page , which used to insert time as UNDEFINE in DTB reservation table **/

      if(this.selectedTime == ''){

        var filterTime = this.bookerArrivalTime;

        var reservationtime = filterTime.replace('T',' ');

        console.log(reservationtime);

      }
      else{
        var reservationtime = this.selectedTime;
      }
      /** END of if/else for NEED A HELP button **/

        // console.log("XOLA ORDER ID "+reservationOrderId);
        // console.log("XOLA ITEM ID "+reservationItemId);

        // console.log(process.env.VUE_APP_RESERVATIONS+'/find_or_create/xola_order_id/'+reservationOrderId+'/xola_item_id/'+reservationItemId);
        axios.post(process.env.VUE_APP_RESERVATIONS+'/find_or_create/xola_order_id/'+reservationOrderId+'/xola_item_id/'+reservationItemId,{
            // person_id: sand + 1,
            xola_order_id: this.bookerTravelerId,
            size: this.bookerTeamSize,
            booker_id: this.bookerDatabaseTableId,
            final_dollar_amount: this.bookerAmount,
            // reservation_for: reservationtime,
            location_id: 1,
            mission_id: this.mission_id
          })
        .then(response => {
            // console.log(response);
            console.log(" inside reservation order by ID");

            this.consistsreservationresult = response.data.id;
            this.reservationIdForReservationMinor = response.data.id;

            var reservationOrderByEmail = this.bookerEmail;
              // console.log(this.bookerEmail);
              // console.log(this.bookername);
              // console.log(reservationOrderByEmail);

              var fullName = this.bookername;
              // console.log(this.bookername);

              var firstName = fullName.split(' ').slice(0, -1).join(' ');
              var lastName = fullName.split(' ').slice(-1).join(' ');
              console.log(firstName);
              console.log(lastName);

              // this.bookerFirstName = firstName;
              // this.bookerLastName = lastName;

              // var firstName = this.bookerFirstName;
              // var lastName = this.bookerLastName;
              // console.log(firstName);
              // console.log(lastName);

              axios.post(process.env.VUE_APP_PEOPLE+'/find_or_create/email/'+reservationOrderByEmail+'/first_name/'+firstName+'/last_name/'+lastName,{
                email: reservationOrderByEmail,
                first_name: firstName,
                last_name: lastName,
                    // date_of_birth: this.date_of_birth,
                    // gender_id: this.gender_id,
                    // marketing_consent: this.promotional_item,
                    // phone: this.phone,
                    // instagram: this.instagram,
                    // waiver_id: this.waiverIdSinged
                  })
              .then(response => {
                console.log(" inside reservation order by email");
                    // console.log(response);
                    // console.log(response.data[0].id);
                    // this.lastPeopleDataId = response.data[0].id;
                    // console.log(this.lastPeopleDataId)

                  })
              .catch(function (error) {
                console.log(error);
              });

            // },


          })
        .catch(function (error) {
          console.log(error);
        });
      },

      submitReservationMinor(){
        console.log("INSIDE RESERVATION MINOR");

        /** if the minor player is selected as TRUE it submits inside reservation_minor **/

        var arr = this.minorsDetail;
      // console.log(arr);

      /** start of for loop **/
      for(var i=0; i < arr.length; i++){

        console.log(this.minorsDetail[i].minorPlayerOrNot);

                     // if(this.minorsDetail[i].minorPlayerOrNot == '1' && this.minorsChecked == 'A'){

                      if(this.minorsChecked == 'A'){

                        // console.log("SOLTIIIIIIIII");
                        var playerMinorIdforReservationMinor1 = this.playerMinorIdList[i];

                        // console.log(this.playerMinorIdList[i]+' yo ho id ');
                        // console.log(playerMinorIdforReservationMinor1);

                        if(this.minorsDetail[i].minorPlayerOrNot == '1'){
                          var non_player_value = '0';
                        }
                        else{
                          var non_player_value = '1';
                        }

                        /** face this issue if one of the Player Minor is NULL on resrvation minor it wont display any other data **/
                        if(playerMinorIdforReservationMinor1 > '0'){

                          var reservationId = this.reservationIdForReservationMinor;

                          // console.log(process.env.VUE_APP_RESERVATION_MINOR+'/find_or_create/player_minor/'+playerMinorIdforReservationMinor1+'/reservation/'+reservationId);

                          axios.post(process.env.VUE_APP_RESERVATION_MINOR+'/find_or_create/player_minor/'+playerMinorIdforReservationMinor1+'/reservation/'+reservationId,{
                            player_minor_id: playerMinorIdforReservationMinor1,
                            reservation_id: this.reservationIdForReservationMinor,
                            arrived: this.waiverSignedOnline,
                            non_player: non_player_value
                          })

                          .then(function (response) {
                            // console.log(response); 
                            // console.log(playerMinorIdforReservationMinor1);
                            console.log('Received player minor value from resrvation id');
                          })
                          .catch(function (error) {
                            console.log(error);
                          });

                        }
                        

                      }
                    }
                    /** END of if clause for minor player for reservation_minor table **/

    // /**** THIS DATA WILL SUBMIT PEOPLE TO PDF FILE ********************************/

      // console.log(this.saveSignatureURL);

      console.log('waiver first name was '+this.first_name);
      console.log('waiver last name was '+this.last_name);
      console.log('waiver email was '+this.email);
      console.log('waiver dob was '+this.date_of_birth);
      // console.log(this.minorsDetail);
      // console.log(this.saveSignatureURL);

      console.log('posting value to waiver pdf url');

      /** test the new waiver update **/

         // console.log('waiver id was 11111');

         //                          console.log(process.env.VUE_APP_PEOPLE+'/updateEmail/'+this.email+'/first_name/'+this.first_name+'/last_name/'+this.last_name+'/reservation_id/'+this.bookerReservationId);

         //                          axios.put(process.env.VUE_APP_PEOPLE+'/updateEmail/'+this.email+'/first_name/'+this.first_name+'/last_name/'+this.last_name+'/reservation_id/'+this.bookerReservationId,{
         //                            waiver_id : '11111',
         //                          })
         //                          .then(response => {
         //                              console.log('updated people id with waiver id as '+waiverId);
         //                              console.log(response);
         //                            })
         //                          .catch(function (error) {
         //                            console.log(error);
         //                          });

         /** end of waiver update **/

         axios.post(process.env.VUE_APP_PDF_WAIVER_URL,{
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          date_of_birth: this.date_of_birth,
          minorsDetail: this.minorsDetail,
          signature: this.saveSignatureURL
        })
         .then(response => {
                      // console.log(response.data);
                      console.log('Created waiver url and it was '+response.data.Location);
                      var awsUrl = response.data.Location;
                      // console.log(awsUrl);

                      /** this will update the URL with AWS link **/

                      var waiverIdFetched = this.waiverIdSinged;
                        // console.log(this.waiverIdSinged);

                        var signedValues = this.saveSignatureURL;
                        // console.log(signedValues + " OLO LO LO ");

                        console.log('aws url was '+awsUrl);

                        axios.post(process.env.VUE_APP_WAIVERS,{
                          waiver_url : awsUrl,
                          online_waiver : 1
                        })
                        .then(response => {
                          console.log(response);
                          console.log("UPDATED WAIVER TABLE with AWS URL");

                          var waiverId = response.data.id;
                                  // console.log(waiverId);
                                  var peopleId = this.people_id;
                                  // console.log("people id "+ peopleId);

                                  /** THIS WILL UPDATE WAIVER ID ON PEOPLE TABLE **/
                                  // axios.put(process.env.VUE_APP_PEOPLE+'/'+peopleId,{
                                  //   waiver_id: waiverId
                                  // })
                                  // .then(response => {
                                  //   console.log('Received data for people detail by id');
                                  // })
                                  // .catch(function (error) {
                                  //   console.log(error);
                                  // });

                                  console.log('waiver id was '+waiverId);

                                  console.log(process.env.VUE_APP_PEOPLE+'/email/'+this.email+'/first_name/'+this.first_name+'/last_name/'+this.last_name+'/reservation_id/'+this.bookerReservationId);

                                  axios.put(process.env.VUE_APP_PEOPLE+'/email/'+this.email+'/first_name/'+this.first_name+'/last_name/'+this.last_name+'/reservation_id/'+this.bookerReservationId,{
                                    waiver_id : waiverId,
                                    postal_code : this.zipCodeInput /** used new code it does not update at the top so using waiver endpoint to update
                                    postal code **/
                                  })
                                  .then(response => {
                                    console.log('updated people id with waiver id as '+waiverId);
                                      // console.log(response);
                                    })
                                  .catch(function (error) {
                                    console.log(error);
                                  });

                                  /** END OF WAIVER ID UPDATE ON PEOPLE TABLE **/

                                })
                        .catch(function (error) {
                          console.log(error);
                        });

                        /** END of AWS link **/

                      })
         .catch(function(error){
          console.log(error);
        });

    // /******************** END OF POST TO WAIVER PDF URL *********************************/
    
  },

  peopleProfileActive(){
    console.log(this.profileClickedIndex);
    console.log(this.profileDetail);
    console.log(this.bookerOrNot);

    for (var i = 0; i < this.profileDetail.length; i++) {

      if(this.profileDetail[i] == this.profileDetail[this.profileClickedIndex]){
        console.log('active profile');
        console.log('activate profile id are '+this.profileDetail[i].id);
        // console.log(this.profileDetail[this.profileClickedIndex]);
        // console.log(this.profileDetail[this.profileClickedIndex].first_name);
        // console.log(this.profileDetail[this.profileClickedIndex].last_name);

        // var getPeopleId = this.profileDetail[this.profileClickedIndex].id;

        //  axios.put(process.env.VUE_APP_PEOPLE+'/'+getPeopleId,{
        //     active: 1,
        //     phone:this.phone,
        //     email:this.email
        //   })
        //   .then(response => {
        //     // console.log(response);
        //     console.log('Activated Profile');
        //   })
        //   .catch(function (error) {
        //     console.log(error);
        //   });
      }
      else{

        console.log('de activate profile');

        var getInactivePeopleId = this.profileDetail[i].id;
        console.log('deactivate profile id are '+this.profileDetail[i].id);
         // axios.put(process.env.VUE_APP_PEOPLE+'/'+getInactivePeopleId,{
         //    active: 0
         //  })
         //  .then(response => {
         //    // console.log(response);
         //    console.log('De-activate Profile');
         //  })
         //  .catch(function (error) {
         //    console.log(error);
         //  });

       }
     }/** end of for loop **/

   },


   submitMinorForm(){

    console.log("consists reservation result");
      // console.log(this.consistsreservationresult);
      // console.log(this.reservationIdForReservationMinor);
      var waiverDataId = this.waiverresult[0];
      if(waiverDataId == null){
        var waiverid = '0';
      }
      else{
        var waiverid = waiverDataId['id'];
      }

      var controlPlayerData = this.newPlayerLastId;
      if(controlPlayerData == null){
        var sand = '0';
      }
      else{
        var sand = controlPlayerData;
        // console.log(this.newPlayerLastId);
      }

      var reservationDataId = this.consistsreservationresult;

      var peopleDataId = this.consistspeopleresult[0];

      // console.log(peopleDataId);

      if(peopleDataId == null){
        var peoplewithid = '0';
      }
      else{
        var peoplewithid = peopleDataId['id'];
      }

      var reservationNewDataId = this.reservationrresult[0];
      if(reservationNewDataId == null){
        var reservationwithnewid = '0';
      }
      else{
        var reservationwithnewid = reservationNewDataId['id'];
      }

      var selectedBookerId = this.bookerTravelerId;
      // console.log(selectedBookerId);


      var lastPlayerIdNew = this.people_id;
      var answerId = this.hearAboutUs;
      var surveyOtherText = this.surveyOtherInput;

      /* post to post_survey_answers */

      if(answerId == '6'){
        console.log("answer Id was 6");
        axios.post(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{
          person_id: lastPlayerIdNew,
          survey_id: 1,
          answer_id: answerId,
          question_id: 1,
          open_text: surveyOtherText
        })
        .then(response => {
          // console.log(response);
          console.log('Person survey answer submitted as 6');
        })
        .catch(function(error){
          console.log(error);
        })

      }
      else{
        console.log("not 6");
        axios.post(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{
          person_id: lastPlayerIdNew,
          survey_id: 1,
          answer_id: answerId,
          question_id: 1
        })
        .then(response => {
          // console.log(response);
          console.log('Person survey answer submitted');
        })
        .catch(function(error){
          console.log(error);
        })
      }

      /* end of post survey answers */


      /** post survey answer 2 **/
      var fetchGetAtBtbAnswer = this.getAtBtb;
      if(fetchGetAtBtbAnswer == '16'){
        console.log("survey for parking answer id was 16");
        axios.post(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{
          person_id: lastPlayerIdNew,
          survey_id: 1,
          answer_id: fetchGetAtBtbAnswer,
          question_id: 2,
          open_text: this.surveyParkCarInput
        })
        .then(response => {
          // console.log(response);
          console.log('Person survey 2 answer was submitted for parking.');
        })
        .catch(function(error){
          console.log(error);
        })

      }
      else{
        axios.post(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{
          person_id: lastPlayerIdNew,
          survey_id: 1,
          answer_id: fetchGetAtBtbAnswer,
          question_id: 2
        })
        .then(response => {
          // console.log(response);
          console.log('Person survey answer submitted for survey question 2.');
        })
        .catch(function(error){
          console.log(error);
        })
      }
      /** end of post survey answer 2 **/

      /** post survey answer 3 for zip code **/
      var fetchZipCode = this.zipCodeInput;
      axios.post(process.env.VUE_APP_PERSON_SURVEY_ANSWER,{
        person_id: lastPlayerIdNew,
        survey_id: 1,
        question_id: 3,
        answer_id: '17', /** zip code id inserted manually **/
        open_text: fetchZipCode
      })
      .then(response => {
          // console.log(response);
          console.log('Person survey answer submitted for zip code.');
        })
      .catch(function(error){
        console.log(error);
      })
      /** end of zip code answer survey **/

      var peopleIdForPlayer = this.people_id;

      if(this.playerSelected == 'yes'){

        // console.log("PLAYER SELECTED AS YESSSSSSSSSSSSSSSSSSSSSSS //// NOOOOOOOOOOOOOOOOOOOOO");
        console.log(" Player detail with id was fetched");


        axios.post(process.env.VUE_APP_PLAYERS+'/find_or_create/'+peopleIdForPlayer,{
        // person_id: peopleIdForPlayer
      })
        .then(response => {
          console.log('Received player detail by id');
          console.log('player details below');
          // console.log(response);
        // console.log(response);

        // console.log(response.data[0].id);

        var playerIdForMinor = response.data[0].id;

        /** this will submit to minor table **/
        var arr = this.minorsDetail;
        var minorvalue = this.minorsDetail[0].first_name;

          // console.log(this.reservationIdForReservationMinor);
          
          var reservationIdUsedOnSession = this.reservationIdForReservationMinor;
          // console.log(reservationIdUsedOnSession);

          if (minorvalue.length > 0) {
            // console.log("INSIDE MINOR");
            for(var i=0; i < arr.length; i++){

              console.log(this.minorsDetail[i].minorPlayerOrNot);

              var playerOrNot = this.minorsDetail[i].minorPlayerOrNot;
                // console.log(playerOrNot);

                axios.post(process.env.VUE_APP_PLAYERMINOR,{
                  first_name: arr[i]['first_name'],
                  last_name: arr[i]['last_name'],
                  date_of_birth: arr[i]['date_of_birth'],
                  player_id: playerIdForMinor
                })

                .then(response => {
                  // console.log(response);

                  // console.log(reservationIdUsedOnSession);

                  var playerMinorIdforReservationMinor = response.data.id;

                  this.playerMinorIdforReservationMinor = response.data.id;

                  this.toplayerMinorIdList = response.data.id;

                  if (this.toplayerMinorIdList > 0) { 
                    this.playerMinorIdList.push(this.toplayerMinorIdList);
                  }


                })
                .catch(function (error) {
                  console.log(error);
                });
                // console.log("Minors added");

              }
            }

            else{
              console.log("No Minors");
            }
            /** end of minor table **/

          })
        .catch(function (error) {
          console.log(error);
        });

      // console.log(this.email);
      // console.log(this.consistspeopleresult);


    }

    else{
      console.log("NOT A PLAYER just a visitor");

        // console.log(" BUT WILL UPDATE THE MINORS");

        /** this part will update as an non-player **/
        var newPersonId = this.people_id;
        var newReservationId = this.consistsreservationresult;

        // console.log(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId);

        axios.post(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId,{
          person_id: this.people_id,
          reservation_id: this.consistsreservationresult,
          arrived: this.waiverSignedOnline,
          non_player: 1
        })
        .then(function (response) {
                // console.log(response);
                console.log('Posted data of visitor using person and reservation');
              })
        .catch(function (error) {
          console.log(error);
        });
        /** end of people updating as non-player **/

        axios.post(process.env.VUE_APP_PLAYERS+'/find_or_create/'+this.people_id,{
            // person_id: this.people_id
          })
        .then(response => {
            // console.log(response);
            console.log('Received visitor id');
            var playerIdForMinor = response.data[0].id;
            // console.log(playerIdForMinor);
            /** this will submit to minor table **/
            var arr = this.minorsDetail;
            var minorvalue = this.minorsDetail[0].first_name;

              // console.log(this.reservationIdForReservationMinor);
              
              var reservationIdUsedOnSession = this.reservationIdForReservationMinor;
              // console.log(reservationIdUsedOnSession);

              if (minorvalue.length > 0) {
                // console.log("INSIDE MINOR");
                for(var i=0; i < arr.length; i++){

                    // console.log(this.minorsDetail[i].minorPlayerOrNot);

                    var playerOrNot = this.minorsDetail[i].minorPlayerOrNot;
                    // console.log(playerOrNot);

                    axios.post(process.env.VUE_APP_PLAYERMINOR,{
                      first_name: arr[i]['first_name'],
                      last_name: arr[i]['last_name'],
                      date_of_birth: arr[i]['date_of_birth'],
                      player_id: playerIdForMinor
                    })
                    .then(response => {
                      // console.log(response);

                      console.log(reservationIdUsedOnSession);

                      var playerMinorIdforReservationMinor = response.data.id;

                      this.playerMinorIdforReservationMinor = response.data.id;

                      this.toplayerMinorIdList = response.data.id;

                      if (this.toplayerMinorIdList > 0) { 
                        this.playerMinorIdList.push(this.toplayerMinorIdList);
                      }


                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                    // console.log("Minors added");

                  }
                }

                else{
                  console.log("No Minors unders NOT A PLAYER sections as well");
                }
                /** end of minor table **/

              })
        .catch(function (error) {
          console.log(error);
        });

          // console.log(this.email);
          // console.log(this.consistspeopleresult);

        }
        /** axios post the bookers table **/

        if(this.playerSelected == 'yes'){

          console.log("UPDATE ON RESERVATION PEOPLE ");

          var newPersonId = this.people_id;
          var newReservationId = this.consistsreservationresult;

            // console.log(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId);

            axios.post(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId,{
              person_id: this.people_id,
              reservation_id: this.consistsreservationresult,
              arrived: this.waiverSignedOnline,
              non_player: 0
            })
            .then(function (response) {
                // console.log(response);
                console.log('Posted data from person and reservation detail');
              })
            .catch(function (error) {
              console.log(error);
            });

          }

          else{
            console.log("NO UPDATE ON RESERVATION PEOPLE");

            var newPersonId = this.people_id;
            var newReservationId = this.consistsreservationresult;

          // console.log(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId);

          axios.post(process.env.VUE_APP_RESERVATIONPEOPLE+'/find_or_create/person/'+newPersonId+'/reservation/'+newReservationId,{
            person_id: this.people_id,
            reservation_id: this.consistsreservationresult,
            arrived: this.waiverSignedOnline,
            non_player: 1
          })
          .then(function (response) {
            console.log(response);
            console.log('Posted data from persons and reservations detail');
          })
          .catch(function (error) {
            console.log(error);
          });

        }

        /** end of bookers table **/

        /** check the reservation id for reservation_people table **/

        var foundReservationId = this.reservationrresult.find((todo) => {
          return todo.xola_order_id == this.bookerTravelerId
          // console.log(todo.travelers.id);
        })

        /** end of reservation_people table **/


        /** if function submits to different database if it contains value on it only **/

      }


    }

  }

  ;
  </script>

  <style>

  /** cellphone PORTRAIT **/
  @media (min-width: 288px) {
    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      width: 96%; /** width: 60%; **/
      margin:auto;
      background-color: #fff;
      height: auto;
    }

    .dateOfBirthStyle{
      margin-left: 5%;
    }

    .playerSpectator{
      /*color: red;*/
      margin-left: 30%;
    }

    #covidText{
      color: red;
    }

    #btbImageLogo{
      width: 80%;
      margin:auto;
    }

    #greetings{
      font-size: 1.4em;
    }

    #selectReservationTime{
      font-size: 1.1em;
    }

    #fetchButtonGap{
      width: 55%;
      margin:auto;
      margin-top: 10px;
      font-size: 1.1em;
    }

    #selectReservationName{
      font-size: 1.1em;
    }

    #selectReservationBookerName{
      font-size: 1.1em;
    }

    #month{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
    }

    #day{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
    }

    #year{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
    }

    #inputField{
      /*height: 40px;*/
      font-size: 1rem;
    }

    .nameTitle{
      font-size: 1.1em;
      text-align: left;
      margin-left: 21%;
    }

    #validationError{ 
      font-size: 0.8em;
      color:red;
    }
    #validationError:before{
      content: "\A";
      white-space: pre;
    }

    .form-control-lg {
      font-size: 1rem;
    }

    #genderText{
      font-size: 1em;
    }

    #genderTitle{
      font-size: 1.4em;
    }

    #hearAboutUsTitle{
      font-size: 0.8em;
    }

    #zipCodeDivTitle{
      font-size: 0.7em;
    }

    #minorNameTitle{
      font-size:1.1em;
    }

    .custom-control-label{
      font-size: 0.9em;
      text-align: justify;
      /*text-align: justify;*/
    }

    #covidFormListingDiv{
      width: auto; 
      margin:auto; 
      text-align:justify;
      font-size: 0.6em;
    }

    #covidForm2{
      text-align: justify; 
      width: 99%; 
      margin: auto;
    }

    #addMinorForm{
      /*background-color: yellow;*/
      width: 90%;
      margin: auto;
    }

    #minorCheckedText{
      font-style: italic; 
      color:red;
      font-size: 0.95em;
    }

    #minorFirstName{
      /*margin-top: 2%;*/
      width: 80%;
      margin: auto;
    }

    #minorLastName{
      /*margin-top: -4%;*/
      width: 80%;
      margin: auto;
    }

    #minorHeading{
      font-size: 1em;
      margin-top: 8%;
    }

    #minorHeadingDOB{
      font-size: 1em;
      margin-top: 5%;
    }

/*  .custom-control-label{
    font-size: 0.95em;
    }*/

    #areYouAPlayer{
      font-size: 1.1em;
      margin-left:-18%;
    }

    #needhelp1{
      width: 120%;
      font-size: 0.9em;
      margin-left: -15%;
    }

    #needhelp2{
      width: 120%;
      font-size: 0.9em;
      height: 40px;
      margin-left: -15%;
    }

    #whereDidYouHear{
      text-align:left;
      margin-left:5%;
      font-size: 0.8em;
    }

    #hearAboutUsNextButton{
      width: 160%;
      margin-left: -25%;
    }

    #hearAboutUsDiv{
      text-align: left;
      margin:auto;
      width: 60%;
      font-size: 1.2em;
    }

    #areYouPlayerDiv{
      margin-left:-18%;
    }

    .work-experiences > div {
      margin: 20px 0;
      padding-bottom: 10px;
    }
    .work-experiences > div:not(:last-child) {
      border-bottom: 1px solid rgb(206, 212, 218);
    }

    #dateDefine{
      margin-left: 0%;
    }

    .input-group-prepend{
      height: 40px;
    }

    #inline-form-input-name{
      height: 40px;
      width: 20%;
      font-size: 0.76em;
    }

    #trashCan{
      margin-top: 5%;
    }

    #defineWidthCovid3{
      width: auto;
      margin:auto;
    }

    #signature {
      border: double 3px transparent;
      border-radius: 5px;
      background-image: linear-gradient(white, white),
      radial-gradient(circle at top left, #4bc5e8, #9f6274);
      background-origin: border-box;
      background-clip: content-box, border-box;
      width: auto !important;
      height: 150px !important;
    }

  }

  /** cellphone LANDSCAPE **/
  @media (min-width: 576px) {
    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
      width: 50%; /** width: 60%; **/
      margin-right:auto; 
      margin-left:auto;
      background-color: #fff;
      height: auto;
    }

    #covidText{
      color: yellow;
    }

    .dateOfBirthStyle{
      margin:auto;
    }

    .playerSpectator{
      margin: auto;
    }

    #btbImageLogo{
      width: 55%;
      margin:auto;
    }

    #greetings{
      font-size: 2.2em;
    }

    #selectReservationTime{
      font-size: 1.7em;
    }

    #fetchButtonGap{
      width: 41%;
      margin:auto;
      margin-top: 10px;
      font-size: 1.1em;
    }

    #selectReservationName{
      font-size: 1.5em;
    }

    #selectReservationBookerName{
      font-size: 1.5em;
    }

    #month{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 18px;
      font-style: normal;
      border-color: #E8E8E8;
      margin-right: 1.5%;
      border-radius: 5px;
      margin-left: 9%;
    }

    #day{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 18px;
      font-style: normal;
      border-color: #E8E8E8;
      margin-right: 1.5%;
      border-radius: 5px;
    }

    #year{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 18px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
      /*margin-right: 10%;*/
    }

    .nameTitle{
      font-size: 1.1em;
      text-align: left;
      margin-left: 21%;
    }

    #genderText{
      font-size: 1.2em;
    }

    #genderTitle{
      font-size: 1.6em;
    }

    #hearAboutUsTitle{
      font-size: 1.4em;
    }

    #zipCodeDivTitle{
      font-size: 1.3em;
    }

    #minorNameTitle{
      font-size:1.3em;
    }

    .custom-control-label{
      font-size: 1.1em;
    }

    #covidFormListingDiv{
      width: 85%; margin:auto; text-align:left;
    }

    #covidForm2{
      text-align: justify; width: 88%; margin: auto;
    }

    #minorCheckedText{
      font-style: italic; 
      color:red;
    }

    #minorFirstName{
      /*margin-top: 2%;*/
      width: 80%;
      margin: auto;
    }

    #minorLastName{
      /*margin-top: -4%;*/
      width: 80%;
      margin: auto;
    }

    #minorHeading{
      font-size: 1em;
      margin-top: 8%;
    }

    #minorHeadingDOB{
      font-size: 1em;
      margin-top: 5%;
    }

    #needhelp1{
      width: 40%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #needhelp2{
      width: 40%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #whereDidYouHear{
      text-align:left;
      margin-left:5%;
      font-size: 1.2em;
    }

    #hearAboutUsNextButton{
      width: auto;
      margin-left: 0%;
    }

    #hearAboutUsDiv{
      text-align: left;
      margin:auto;
      width: 60%;
      font-size: 1.2em;
    }

    #areYouPlayerDiv{
      margin-left:-50%;
    }

    #areYouAPlayer{
      font-size: 1.1em;
      margin-left:-50%;
    }

    .work-experiences > div {
      margin: 20px 0;
      padding-bottom: 10px;
    }
    .work-experiences > div:not(:last-child) {
      border-bottom: 1px solid rgb(206, 212, 218);
    }

    #dateDefine{
      margin-left: 0%;
    }

    .input-group-prepend{
      height: auto;
    }

    #inline-form-input-name{
      height: auto;
      width: auto;
      font-size: 1em;
    }

    #trashCan{
      margin-top: 25%;
    }

    #defineWidthCovid3{
      width: auto;
      margin:auto;
    }

    #signature {
      border: double 3px transparent;
      border-radius: 5px;
      background-image: linear-gradient(white, white),
      radial-gradient(circle at top left, #4bc5e8, #9f6274);
      background-origin: border-box;
      background-clip: content-box, border-box;
      width: auto !important;
      height: 150px !important;
      /*background-color: red;*/
      margin:auto;
    }

  }

  /** tablets **/
  @media (min-width: 768px) {
    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
      width: 99%; /** width: 60%; **/
      margin-right:auto; 
      margin-left:auto;
      background-color: #fff;
      height: auto;
    }

    #covidText{
      color: green;
    }

    .dateOfBirthStyle{
      margin:auto;
    }

    .playerSpectator{
      margin: auto;
    }

    #btbImageLogo{
      width: 65%;
      margin:auto;
    }

    #greetings{
      font-size: 2.2em;
    }

    #selectReservationTime{
      font-size: 1.6em;
    }

    #fetchButtonGap{
      width: 41%;
      margin:auto;
      margin-top: 10px;
      font-size: 1.1em;
    }

    #selectReservationName{
      font-size: 1.5em;
    }

    #selectReservationBookerName{
      font-size: 1.5em;
    }

    #month{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      margin-right: 1.5%;
      border-radius: 5px;
      margin-left: -26%;
    }

    #day{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      margin-right: 1.5%;
      border-radius: 5px;
    }

    #year{
      height: 30px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 16px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
      /*margin-right: 30%;*/
    }

    .nameTitle{
      font-size: 1.1em;
      text-align: left;
      margin-left: 21%;
    }

    #genderText{
      font-size: 1.2em;
    }

    #genderTitle{
      font-size: 1.6em;
    }

    #hearAboutUsTitle{
      font-size: 1.13em;
    }

    #zipCodeDivTitle{
      font-size: 1.2em;
    }

    #minorNameTitle{
      font-size:1.3em;
    }

    .custom-control-label{
      font-size: 1.1em;
    }

    #covidFormListingDiv{
      width: 90%;
      margin:auto;
      text-align:justify;
      font-size: 0.9em;
    }

    #covidForm2{
      text-align: justify;
      width: 99%;
      margin: auto;
    }

    #minorCheckedText{
      font-style: italic; 
      color:red;
    }

    #minorFirstName{
      /*margin-top: 2%;*/
      width: 98%;
      margin: auto;
    }

    #minorLastName{
      /*margin-top: -4%;*/
      width: 98%;
      margin: auto;
    }

    #minorHeading{
      font-size: 0.93em;
      margin-top: 8%;
    }

    #minorHeadingDOB{
      font-size: 0.98em;
      margin-top: 3.5%;
      margin-left: 0%;
    }

    #needhelp1{
      width: 70%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #needhelp2{
      width: 70%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #whereDidYouHear{
      text-align:left;
      margin-left:5%;
      font-size: 1.2em;
    }

    #hearAboutUsNextButton{
      width: auto;
      margin-left: 0%;
    }

    #hearAboutUsDiv{
      text-align: left;
      margin:auto;
      width: 60%;
      font-size: 1.2em;
    }

    #areYouPlayerDiv{
      margin-left:-22%;
    }

    #areYouAPlayer{
      font-size: 1.2em;
      margin-left:-39.5%;
    }

    #addMinorForm{
      /*background-color: yellow;*/
      width: 100%;
      margin: auto;
    }

    .work-experiences > div {
      margin: 20px 0;
      padding-bottom: 10px;
    }
    .work-experiences > div:not(:last-child) {
      border-bottom: 1px solid rgb(206, 212, 218);
    }

    #dateDefine{
      margin-left: 22%;
    }

    .input-group-prepend{
      height: auto;
    }

    #inline-form-input-name{
      height: auto;
      width: auto;
      font-size: 1em;
    }

    #trashCan{
      margin-top: 25%;
    }

    #defineWidthCovid3{
      width: auto;
      margin:auto;
    }

    #signature {
      border: double 3px transparent;
      border-radius: 5px;
      background-image: linear-gradient(white, white),
      radial-gradient(circle at top left, #4bc5e8, #9f6274);
      background-origin: border-box;
      background-clip: content-box, border-box;
      width: 400px !important;
      height: 200px !important;
      /*background-color: red;*/
      margin:auto;
    }

  }

  /** desktop **/
  @media (min-width: 992px) {
    #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      margin-top: 60px;
      width: 90%; /** width: 60%; **/
      margin-right:auto; 
      margin-left:auto;
      background-color: #fff;
      height: auto;
    }

    .dateOfBirthStyle{
      margin:auto;
    }

    .playerSpectator{
      margin: auto;
    }

    #defineWidthCovid3{
      width: 50%;
      margin:auto;
    }

    #btbImageLogo{
      width: auto;
      margin:auto;
    }

    #greetings{
      font-size: 2.2em;
    }

    #selectReservationTime{
      font-size: 1.7em;
    }

    #fetchButtonGap{
      width: 18%;
      margin:auto;
      margin-top: 10px;
      font-size: 1.1em;
    }

    #selectReservationName{
      font-size: 1.7em;
    }

    #selectReservationBookerName{
      font-size: 1.7em;
    }

    #month{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 17px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
      margin-left: -42%;
    }

    #day{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 17px;
      font-style: normal;
      border-color: #E8E8E8;
      margin-right: 1.5%;
      border-radius: 5px;
    }

    #year{
      height: 38px;
      color: black;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 17px;
      font-style: normal;
      border-color: #E8E8E8;
      border-radius: 5px;
    }

    .nameTitle{
      font-size: 1.1em;
      text-align: left;
      margin-left: 21%;
    }

    #validationError{ 
      font-size: 1.1em;
      color:red;
    }

    #genderText{
      font-size: 1em;
    }

    #genderTitle{
      font-size: 1.4em;
    }

    #hearAboutUsTitle{
      font-size: 1.4em;
    }

    #zipCodeDivTitle{
      font-size: 1.0em;
    }

    #minorNameTitle{
      font-size:1.3em;
    }

    #minorHeadingDOB{
      font-size: 1.3em;
      margin-top: 3%;
      margin-left: 20%;
    }

    /** this css is linked with gender input radio button as well **/
    .custom-control-label{
      font-size: 1.1em;
      width: auto;
      /*background-color: yellow;*/
    }

    #covidFormListingDiv{
      width: 44%; 
      margin:auto; 
      text-align:justify;
      /*background-color: red;*/
    }


    #covidForm2{
      text-align: left; 
      width: 45%; 
      margin: auto;
    }

    #addMinorForm{
      /*background-color: yellow;*/
      width: 65%;
      margin-left: 20%;
    }

    #minorCheckedText{
      font-style: italic; 
      color:red;
    }

    #minorFirstName{
      /*margin-top: 2%;*/
      width: 110%;
      margin-left: 10%;
    }

    #minorLastName{
      /*margin-top: -4%;*/
      width: 110%;
      margin-left: 20%;
    }

    #minorHeading{
      font-size: 1.2em;
    }

    #needhelp1{
      width: 40%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #needhelp2{
      width: 40%;
      font-size: 1.1em;
      margin-left: 0%;
    }

    #whereDidYouHear{
      text-align:left;
      margin-left:5%;
      font-size: 1.2em;
    }

    #hearAboutUsNextButton{
      width: auto;
      margin-left: 0%;
    }

    #hearAboutUsDiv{
      text-align: left;
      margin:auto;
      width: 60%;
      font-size: 1.0em;
    }

    #areYouPlayerDiv{
      margin-left:-42.5%;
    }

    #areYouAPlayer{
      font-size: 1.1em;
      margin-left:-50%;
    }

    .work-experiences > div {
      margin: 20px 0;
      padding-bottom: 10px;
      /*background-color: yellow;*/
    }
    .work-experiences > div:not(:last-child) {
      border-bottom: 1px solid rgb(206, 212, 218);
    }

    #dateDefine{
      margin-left: 50%;
    }

    .input-group-prepend{
      height: auto;
    }

    #trashCan{
      margin-top: 25%;
      margin-left: -20%;
    }

    #signature {
      border: double 3px transparent;
      border-radius: 5px;
      background-image: linear-gradient(white, white),
      radial-gradient(circle at top left, #4bc5e8, #9f6274);
      background-origin: border-box;
      background-clip: content-box, border-box;
      width: 400px !important;
      height: 200px !important;
      /*background-color: red;*/
      margin:auto;
    }
 /* #inline-form-input-name{
    height: auto;
    width: auto;
    font-size: 1em;
    }*/

  }

  /*#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    width: auto; 
    margin-right:auto; 
    margin-left:auto;
    background-color: #fff;
    height: auto;
    }*/

    .b-form-group .label{
      font-size: 6em;
    }

    #inputField{
      width: 60%;
      margin: auto;
    }


    #minorsInput{
      width: 40%;
      margin: auto;
    }

    #dateDropdownDesign{
      margin:auto;
      width: auto;
      /*background-color: yellow; */
    }

    .fullNameTitle{
      font-size: 1.3em;
      text-align: left;
      margin-left: 21%;
    }

    .reservationTimeOption{
      width: 50%;
      font-size: 1.3em;
    }

    .instagramField{
      width: 60%;
      margin: auto;
    }

    .selectedBookingTime{
      font-size: 1.5em;
    }

    .waiverSubmittedClass{
      font-size: 1.1em;
      text-align: left;
      margin-top: 8%;
      margin-left: 5%;
      color: #17a2b8;
    }

    #minorsInputFullname{
      margin-left: 0%;
    }

    #minorsInputDiv{
      margin-right: 7%;
    }

    .custom-control-lg .custom-control-label::before,
    .custom-control-lg .custom-control-label::after {
      top: 0.1rem !important;
      left: -2rem !important;
      width: 1.25rem !important;
      height: 1.25rem !important;
      border-color: red;
    }

    #minorPlayerCheckBox{
      width: 1.5rem !important;
      height: 1.5rem !important;
    }

    /** style below is for the progress bar **/

    .progressBarContainer {
      width: 20%;
      background-color: #ddd;
      margin:auto;
      border-radius: 25px;
      padding: 0.1%;
    }

    .progressBarSkills {
      text-align: right;
      padding-top: 0.9%;
      padding-bottom: 0.9%;
      color: white;
    }

    .question1 {width: 0%;}
    .question2 {width: 15%; background-color: #0069D9;border-radius: 25px;text-align: center;
      padding: 3px;}
      .question3 {width: 30%; background-color: #0069D9;border-radius: 25px;text-align: center;
        padding: 3px;}
        .question4 {width: 45%; background-color: #0069D9;border-radius: 25px;text-align: center;
          padding: 3px;}
          .question5 {width: 60%; background-color: #0069D9;border-radius: 25px;text-align: center;
            padding: 3px;}
            .question6 {width: 75%; background-color: #0069D9;border-radius: 25px;text-align: center;
              padding: 3px;}
              .question7 {width: 90%; background-color: #0069D9;border-radius: 25px;text-align: center;
                padding: 3px;}

                /** end of progress bar **/


                </style>
